const datas = {
    new_datas: [
        // {
        //     addr: '/news/one',
        //     date: '2025.08.26',
        //     title: '富轹集团与中沙经济发展委员会战略合作',
        //     img: '',
        //     content: {
        //         subheading: ``,
        //         data: [
        //             { img: require('../../assets/images/'), text: ``},
        //             { img: require('../../assets/images/'), text: ``},
        //             { img: require('../../assets/images/'), text: ``},
        //             { img: require('../../assets/images/'), text: ``},
        //         ],
        //         summarize: ''
        //     }
        // },

        {
            addr: '/news/one',
            date: '2025.11.08',
            title: '中国县域经济发展大会总部落户温州',
            img: require('../../assets/images/25110801.png'),
            content: {
                subheading: `11月8日，中国县域经济发展大会2025年会在浙江温州举行。本届大会以“县域未来，城乡融合”为主题，来自全国各地的知名专家学者、县市代表及企业界人士等200余人汇聚一堂，共同探讨县域经济发展的前沿趋势与创新实践。年会确定中国县域经济发展大会总部正式落户温州`,
                data: [
                    { img: require('../../assets/images/25110801.png'), text: `近日，中国县域经济发展大会2025年会在温州开幕。大会总部基地的永久落户温州，不仅是对“温州模式”的高度肯定，更标志着全国县域经济迈入了从“规模扩张”向“质量攻坚”转型的新阶段。与会专家强调，“十五五”期间，县域经济发展必须紧扣人工智能、城乡融合、绿色转型、县域治理四大重点，彻底摒弃“一刀切”模式，全面转向精准施策。在此背景下，实现高端产业的“精准招引”成为县域经济破局的关键。这意味着一场根本性的转变：从过去“捡到篮子里都是菜”的“地毯式”招商，升级为运用系统思维的“导航式”精准选商。
精准招引，其核心在于“精准”。它要求县域政府从被动承接产业转移，转向主动谋划和定义自身的产业未来。其内核包含三个层面：战略匹配度精准：招引的产业必须与县域的核心资源禀赋、战略定位及长远规划高度契合。不应追逐所有看似“高大上”的产业，而应寻找与自身“基因”相匹配的细分领域。目标企业精准：从“招商引资”变为“招商选资”。不再广撒网，而是精准识别产业链条上最关键、最互补的环节，并锁定该环节中的“专精特新”、隐形冠军或具有强大带动力的龙头企业。政策与服务精准：提供的政策扶持与政务服务，必须与企业发展的痛点、难点深度绑定，实现“一企一策”、“按需配送”，打造不可替代的营商环境软实力。正如大会所强调，温州模式的精髓在于其因地制宜、敢为人先的精神。“十五五”时期的精准招引，正是这种精神在新时代的传承与升华。
在出动招商之前，县域必须完成内在的“顶层设计”与“自我剖析”，这是精准招引的前提。清晰的产业定位与画像基于优势分析：深入盘点自身的产业基础、自然资源、区位交通、人力资本、乡土文化等。例如，具备农业基础的县域，可瞄准智慧农业、生物制造、功能性食品等高端细分领域；拥有山水资源的县域，可聚焦低碳旅游、康养医养、生态价值实现等产业。融入区域战略：将自身发展置于国家与省市的区域发展战略中（如城市群、经济带），寻找差异化、互补性的产业机会。避免与周边地区同质化竞争，构建“竞合”关系。聚焦细分赛道：高端产业范围广阔，县域资源有限，必须聚焦。例如，发展人工智能产业，不应追求全产业链，而可专注于“AI+特定场景应用”，如AI+泵阀故障诊断（对于机械制造强县）、AI+皮革面料设计（对于轻纺业强县）。深度的产业链诊断
运用产业链图谱工具，对县域现有主导产业和欲发展的新产业进行“解剖”。补链：识别现有产业链中的缺失环节和薄弱环节，针对性地招引相关企业，提升产业链的完整性和韧性。强链：在优势环节上，招引技术更先进、附加值更高的企业，进一步巩固和扩大优势。延链：向产业链的上下游延伸，特别是向研发设计、品牌营销、售后服务等微笑曲线两端的高附加值环节拓展。务实的承载平台打造
高端产业对承载空间有更高要求。必须提前规划建设好功能完备的产业平台。专业化园区：建设符合特定产业需求的标准化厂房、专用基础设施（如双回路电、特殊气体供应）、共享实验室和中试基地。数字化基础设施：落实大会发布的“AI+数智县域平台云”，确保园区及县域具备高效的数据传输与处理能力，为智能制造、数字经济发展奠定“数字基座”。
有了清晰的“导航图”，接下来需要运用多元化的策略，进行精准“出击”。产业链招商：从“点”到“链”的突破
这是最核心、最有效的路径。围绕主导产业，锁定产业链上的关键企业，以其为“磁极”，吸引上下游配套企业集聚。案例：若成功引进一家新能源电池正极材料龙头企业，便可顺势招引前驱体、负极材料、隔膜、电池管理系统等配套企业，以及后端的新能源装备、电池回收等企业，快速形成产业集群。资本招商：用资金杠杆撬动产业未来
`},
                    { img: require('../../assets/images/25110802.png'), text: `改变单纯依靠土地、税收优惠的传统模式，善于运用产业引导基金、股权投资等市场化手段。操作：设立县域产业引导基金，以“母基金+子基金”模式，联合社会资本，直接投资或吸引有潜力的创新科技企业落户。这不仅能解决企业早期的资金难题，更能通过资本的纽带，与企业发展深度绑定。平台招商与生态招商：构建“热带雨林”式创新生态借力大会平台：充分利用此次落户温州的“中国县域经济发展大会总部基地”这一国家级平台，常态化举办产业论坛、创新大赛、成果对接会，将县域打造成思想交汇和产业合作的枢纽，吸引高端资源“不请自来”。构建创新生态：积极引入高校研究院所、重点实验室、技术转移中心、工业设计中心等创新机构。一个活跃的创新生态，对高端人才和高技术企业具有天然的吸引力。“人才+技术”招商：瞄准创新的源头
高端产业的核心是人才与技术。可以实施“双招双引”（招商引资与招才引智）联动。策略：通过“揭榜挂帅”等方式，发布企业技术需求，吸引全球科研团队攻关，最终将科技成果在本地产业化。同时，以高端人才（如一个顶尖科学家团队）为核心，带动一个创新企业的落地，实现“引进一个人才，带来一个团队，办起一个企业，兴起一个产业”的链式反应。场景招商：为新技术提供“试验场”
对于人工智能、数字科技等新兴产业，县域可以主动开放政府管理、公共服务、传统产业升级等应用场景。例如：发布“智慧交通”、“数字医疗”、“智慧农业”等场景清单，邀请相关企业带着解决方案前来“打样”。一旦测试成功，不仅解决了本地问题，也帮助企业验证了技术和商业模式，自然能吸引企业设立分支机构或研发中心。
精准招引的成果，最终需要靠卓越的县域治理来巩固和放大。这正是大会专家所指出的“机制设计与平台搭建”的核心要义。数据驱动的精准治理
依托“县域经济指数”和“AI+数智县域平台云”，实现对县域经济运行、企业经营状况的实时监测和智能分析。政府决策从“经验主导”转向“数据驱动”，能够更早地发现企业困难，更准地预测产业趋势，从而提供前瞻性服务。打造稳定、透明、可预期的营商环境政策稳定性：保持产业政策的连续性和稳定性，让企业敢于做长期投资和技术研发。政务服务高效性：深化“放管服”改革，推行“一网通办”、“拿地即开工”等模式，最大限度降低制度性交易成本。法治保障：加强知识产权保护，让创新者的权益得到充分尊重，这是吸引高端科技企业的定心丸。推动绿色转型与城乡融合绿色门槛：将“绿色转型”理念融入招商标准，设置能耗、环保、碳排放等准入门槛，招引的项目必须是环境友好型、资源节约型的，这本身也是对产业质量的筛选。城乡协同：通过高端产业的引入，创造高质量的就业岗位，吸引人才回流。同时，规划好产业空间与城市功能、乡村风貌的协调发展，打造“产城人”融合、城乡共富的样板，以此作为吸引高端人才的独特优势。
`},
                    { img: require('../../assets/images/25110803.png'), text: ``},
                ],
                summarize: `“十五五”的征程已经开启，县域经济正站在一个从量变到质变的历史关口。精准招引高端产业，是一场考验县域主政者战略眼光、系统思维和治理能力的综合大考。它要求我们放下“速度情结”和“总量焦虑”，以“面朝未来”的视野，绘制独具特色的“产业导航图”；以“十年磨一剑”的定力，深耕细作产业生态。正如温州以其独特的模式开创了民营经济的先河，未来的中国县域，也必将在精准招引的实践中，涌现出更多基于自身资源禀赋、顺应科技革命浪潮、践行绿色发展理念的“新温州模式”，在全国经济高质量发展的宏大画卷中，写下各自浓墨重彩的篇章。`
            }
        },

        {
            addr: '/news/one',
            date: '2025.10.20',
            title: '喜报！雷亚电子获批国家级专精特新 “小巨人”企业称号',
            img: '',
            content: {
                subheading: `10月20日，工信部公布第七批国家级专精特新 “小巨人” 企业名单，浙江雷亚电子有限公司成功登榜。`,
                data: [
                    { img: require('../../assets/images/25102401.jpg'), text: `专精特新“小巨人”企业，是指专注于细分市场、创新能力强、市场占有率高、掌握关键核心技术、质量效益优的排头兵企业，是中小企业评定工作中等级最高、最具权威的荣誉称号。它们规模可能不大，但在产业链的关键环节发挥着“补短板”“锻长板”“填空白”等重要作用，是解决关键技术难题、推动产业升级的重要力量。`},
                    { img: require('../../assets/images/25102402.png'), text: `浙江雷亚电子有限公司是一家专业的电子行业制造商之一，具有10年以上行业研发经验，制造、营销和服务。企业生产类别分别包括：电源逆变器，带充电器的逆变器、变频发电机、电池充电器、直流转换器等。凭借其广泛的产品组合，公司为世界打造便捷的移动生活做出了重要贡献。在发电和存储能源解决方案、娱乐和住宅解决方案、公用光伏解决方案、便携式电站方面，全球客户对雷亚电子及其尖端解决方案高度评价。除了已建立的业务领域，雷亚电子还在人工智能、工业物联网 (IIoT)、云解决方案等未来技术上进行了大量投资。`},
                ],
                summarize: ''
            }
        },
         {
            addr: '/news/one',
            date: '2025.10.20',
            title: '《华人经济》专访富轹科技集团董事长麦弘毅先生',
            img: '',
            content: {
                subheading: `编者按：《华人经济》是由今日华人出版社出版，蜚声海内外的知名经济类期刊。现全文转发《华人经济》对浙江富轹科技集团董事长麦弘毅先生的专访文章。`,
                data: [
                    { img: require('../../assets/images/25102001.jpg'), text: `麦弘毅先生，浙江富轹科技集团有限公司董事长、原中信阿里云机器人产业园负责人。他目光长远，善于与时俱进不断寻求新的发展。其职业生涯跨互联网科技、制造业、农业、产业园等多个领域，成就有目共睹。未来，他将重点关注全球南方市场，希望在合作共赢中，实现企业新的突破。
文章着重介绍了麦弘毅先生从九十年代的互联网先行者，到开拓内地市场的实业家，再到如今各类型产业园的打造者，以敢拼敢闯、突破创新的精神不断进行多元化尝试的职业历程。
麦弘毅先生现担任浙江富轹科技集团有限公司负责人，他介绍道：“温州是传统制造企业的摇篮，但随着社会的不断发展，人工成本越来越高，许多企业的技术业已老化，亟需转型升级。”
2020年，浙江富轹科技集团有限公司联合中信集团、阿里巴巴集团旗下阿里云，在国家级战略重地——温州瓯江口新区，置地355亩并聚力打造了63万平方米的“中信—阿里云|瓯江口机器人产业园”。`},
                    { img: require('../../assets/images/25102002.png'), text: `该产业园为浙江省重点项目，位列152工程，总投资25亿元。园区由机器人研发和生产基地、机器人应用示范区、机器人博物馆及配套工程组成，将打造一个以机器人制造、系统集成、零部件生产、智能产业示范等生态链组成的产业集群，力争成为浙江乃至全国的智能制造示范基地，并重塑城市工业新格局、点亮温州智造新未来。目前，该园现已聚集多家领先机器人制造商、智能科技企业。
有了第一个产业园的成功样板，后续便邀约不断。“我们参与打造的第三个产业园在福建霞浦，2023年已完成置地，当前在紧锣密鼓地设计规划中。”麦弘毅先生介绍，“霞浦政府希望我们再做一个中马食品深加工产业园，因此，我们同步也在开展与马来西亚方面合作的项目。”
2024年是中马建交50周年暨“中马友好年”，50年来，中马坚持相互尊重、平等互利、合作共赢，各领域合作取得重要成果，双边关系保持良好发展势头，始终走在中国同东盟国家关系前列，成为睦邻友好、合作共赢的典范。麦弘毅先生指出，打造中马食品深加工产业园肯定是双赢之举：一方面，随着欧美市场对中国内地产品的设限越来越多，中国品牌想要突破制裁走出去，加强与东盟的合作是不二之选；另一方面，马来西亚方面资源丰富，亦有不少企业想要开拓中国市场。他迫切希望，透过这一姊妹产业园，能够帮助更多企业走出去、引进来，进一步深化中马合作。
在世界经济版图的悄然变动中，一股不可忽视的力量正以前所未有的速度重塑全球商业格局——中国公司正以迅猛的姿态进军全球南方市场。对于这一点，麦弘毅先生看得非常清楚。透过在沙特阿拉伯的考察，他发现，沙特正在筹备2030年世界博览会，有着庞大的基建需求，而这正好是中国的强项；南美洲国家苏里南对农机等生产设备存在需求，生产这些设备，中国企业可谓驾轻就熟……如果能促成各方面合作，一定是多赢的。`},
                    { img: require('../../assets/images/25102003.png'), text: `而这，正是麦弘毅先生接下来想做的。2024年8月底，他陪同沙特政府代表考察了广州知识城几家医疗系统；之后又去到了义乌考察，并和对外投资局局长进行座谈；还在温州考察了几家自动化生产设备企业；更到株洲实地考察了中车集团……一连串的活动，不仅让他开阔了眼界，亦更加坚定了信心。与时代同行，争做弄潮儿，他相信这不仅是社会发展之趋势，亦是企业未来发展之需要。`},
                ],
                summarize: ''
            }
        },

        {
            addr: '/news/one',
            date: '2025.10.17',
            title: '富轹集团与中沙经济发展委员会战略合作',
            img: '',
            content: {
                subheading: `【编者按】瓯江口机器人产业园是温州海经区的明星智慧园区，政府和园区通过政策支持和贴心服务不断优化营商环境，提供发展便利，众多企业选择来这里创业发展，蓬勃成长。让我们一起关注和见证这些优秀园区企业的成长历程。      浙江永昇汽车部件有限公司于2024年初迁入机器人产业园，从夫妻携手创业，到女儿女婿接棒传承，两代人用技术匠心与品牌雄心，将一家小小的汽车部件公司，打造成连接器领域的“隐形冠军”。`,
                data: [
                    { img: require('../../assets/images/25101701.jpg'), text: `在海经区这片充满活力的热土上，每一个厂房的灯火、每一次技术的突破，都藏着民营企业家“热辣滚烫”的奋斗故事，故事里有白手起家的传奇，有技术攻坚的执着，更有政企同心优化营商环境的温暖。“温暖营商・海经故事”专题系列报道将带领大家走进海经区民营企业家的世界，倾听他们在海经区创新创业心声，见证企业与海经区双向奔赴的成长，探寻民营经济蓬勃发展背后的力量。`},
                    { img: require('../../assets/images/25101702.jpg'), text: `“我们是‘新温州人’。”浙江永昇汽车部件有限公司董事长任付生与法定代表人李萍枝是一对夫妻，也是大学校友。1986年从塑料成型专业毕业后，他们进入当时国内汽车连接器龙头企业“鹤壁天海”，积累了深厚的技术底蕴。2001年，受温州企业力邀，他们举家南迁，从河南来到温州，成为温州汽车零部件行业早期的技术拓荒者。
2010年，看准汽车行业爆发式增长的机遇，他们毅然创办永胜汽车部件有限公司。“我们是技术出身，对产品质量有执念。”李萍枝说，正是这份对技术的坚持，让公司在创业初期就赢得了客户的信任，订单源源不断。
2024年初，公司迁入海经区自建标准化厂房，使用面积达7000多平方米，并正式更名为浙江永昇汽车部件有限公司，产能从原来的2000多万元提升至近7000万元。“现在场地又不够用了，”任付生笑称，“我们正在计划申请新的厂房用地。”`},
                    { img: require('../../assets/images/25101703.jpg'), text: `2012年，女儿任斐大学毕业后加入公司；2014年，女婿丁轩也紧随其后。两位年轻人没有空降高位，而是从仓库、质检、设计等基层岗位做起，一步步熟悉产品与流程。
“老一辈更专注技术与生产，我们则带来了打造品牌化的新思路。”总经理丁轩介绍，2016年公司上线阿里巴巴国内站，2018年又开通国际站，主动拥抱电商与外贸，持续推广自主品牌“YOSCN”。“刚开始老一辈不太理解，觉得我们‘不务正业’，但后来看到订单实实在在地增长，他们也逐渐认可了。”
如今，外贸业务已占公司总产值的20%，产品远销俄罗斯、伊朗、欧洲和南美。任斐负责的外贸板块，更是通过定制化开发与自动化生产，赢得了国际客户的长期信赖`},
                    { img: require('../../assets/images/25101704.jpg'), text: `“用科技对产品保驾护航，是我们对客户承诺最硬的底气。”面对新能源汽车的浪潮，永昇以“智造”破局。2020年，公司启动智能化改造，引入CCD视觉检测、智能集中供料系统及全自动装配检测线，高标准打造自动化车间，精准应对“用工荒”，极致追求产品一致性与可靠性。入驻海经区后，公司更加注重智能化改造升级，进一步推动智能制造全覆盖，建设数字化车间（MES系统），实现质量全程可追溯。
丁轩表示，选择海经区，正是看中了这里“温暖的营商土壤”。海经区不仅区位优势明显，政府服务更是贴心。“管委会和机器人产业园区相关负责人多次走访，主动为我们与浙江工贸职业技术学院牵线搭桥。”如今，稳定的“订单式”校企合作为企业注入了新鲜血液，2024年以来，已有多名该校优秀实习生顺利转正。此外，政府还带队帮助企业对接主机厂，为业务拓展赋能。
“我们从夫妻创业，到儿女接班，靠的就是‘坚守’两个字。”任付生说，“创业难，守业更难。但我们相信，只要一家人同心，企业就能走得更远。”永昇正以两代人的接力，书写着一个关于技术、传承与创新的“连接器”故事——连接的不只是汽车部件，更是家人与未来。`},
                ],
                summarize: ''
            }
        },

        {
            addr: '/news/one',
            date: '2025.10.13',
            title: '国家发改委调研组莅临霞浦富轹海洋经济产业园调研',
            img: '',
            content: {
                subheading: `10 月 13 日下午，国家发改委调研组莅临霞浦富轹海洋经济产业园调研，实地察看园区建设与产业布局。县经开区管委会相关领导、产业园项目负责人诸总全程陪同接待。`,
                data: [
                    { img: require('../../assets/images/25101301.jpg'), text: ``},
                    { img: require('../../assets/images/25101302.jpg'), text: `在项目现场，诸总介绍，作为省级重点工程，园区工程建设已完成 90%工程量，目前附属工程已全面开工建设，预计 2026 年 6 月全面交付使用。随后据诸总介绍，园区以旧地盘活模式构建海洋食品产业从”原料 - 加工 - 仓储 - 销售、融资”全产业链闭环，项目投产后年总产值预计 6 亿元，带动百余家企业入驻；助力霞浦海产品打响 “千鲜之城” 品牌。`},
                    { img: require('../../assets/images/25101303.jpg'), text: `调研组结合全国战略提出指导：依托霞浦资源突破海产品加工技术、提升附加值；探索 “生态保护 + 产业发展” 路径；强化政企协同，对接惠企政策培育海洋新质生产力。诸总表示，将加快完善配套、优化营商环境，推动园区成区域海洋经济升级 “新引擎”。`},
                ],
                summarize: ''
            }
        },

         {
            addr: '/news/one',
            date: '2025.09.27',
            title: '厦大管院博士生实践团赴霞浦富轹海洋经济产业园调研',
            img: '',
            content: {
                subheading: `9月27日上午，厦门大学管理学院“知行计划”博士生实践团走进霞浦富轹海洋经济产业园调研，以学术视角看霞浦产业发展；县组织部、经开区等领导陪同，项目负责人高灿、胡广明携团队接待。`,
                data: [
                    { img: require('../../assets/images/25092701.jpg'), text: ``},
                    { img: require('../../assets/images/25092702.jpg'), text: `经项目负责人详细介绍园区的规划理念、空间布局、产业定位与升级目标、及重点项目对地方经济发展的深远意义，在项目展厅现场实践团一行就海洋食品产业的链条构建，到未来在海洋经济领域的产业更新创新突破方向等问题展开提问。`},
                    { img: require('../../assets/images/25092703.jpg'), text: `随后项目负责人围绕如何进一步解决海洋食品产业发展痛点、提升产业经济效益、产业园区平台如何解决企业面临发展问题等议题，与实践团一行进行详细介绍，霞浦海洋经济产业作为海洋食品发展的重要承载平台，将从原料加工、高端设备替代、产品精加工、仓储物流、成品批发零售等全方位赋能产业链升及发展。`},
                    { img: require('../../assets/images/25092704.jpg'), text: ``},
                    { img: require('../../assets/images/25092705.jpg'), text: ``},

                ],
                summarize: ''
            }
        },

        {
            addr: '/news/one',
            date: '2025.08.30',
            title: '新沃电气卢义雄、冯彬彬：匠心伉俪的电力金具创业路',
            img: '',
            content: {
                subheading: `【编者按】瓯江口机器人产业园是温州海经区的明星智慧园区，政府和园区通过政策支持和贴心服务不断优化营商环境，提供发展便利，众多企业选择来这里创业发展，蓬勃成长。让我们一起关注和见证这些优秀园区企业的成长历程。      浙江新沃电气有限公司于2023年8月入驻机器人产业园，企业家伉俪卢义雄、冯彬彬用行动诠释了“做好人、做好产品、做好服务就是最好的广告”，借力机器人产业园平台让企业不断深耕发展，保持领先。`,
                data: [
                    { img: require('../../assets/images/25083001.jpg'), text: `在海经区这片充满活力的热土上，每一个厂房的灯火、每一次技术的突破，都藏着民营企业家“热辣滚烫”的奋斗故事，故事里有白手起家的传奇，有技术攻坚的执着，更有政企同心优化营商环境的温暖。“温暖营商・海经故事”专题系列报道将带领大家走进海经区民营企业家的世界，倾听他们在海经区创新创业心声，见证企业与海经区双向奔赴的成长，探寻民营经济蓬勃发展背后的力量。`},
                    { img: require('../../assets/images/25083002.jpg'), text: `从开着一辆车跑遍全国多地找客源，到累计投入数百万元研发试验提品质；从创业初期的举步维艰，到如今客户纷至沓来，综合产值过亿……浙江新沃电气有限公司“伉俪掌舵者”——董事长卢义雄和总经理冯彬彬用行动诠释着“做好人、做好产品、做好服务就是最好的广告”。`},
                    { img: require('../../assets/images/25083003.jpg'), text: `2010年6月，怀揣着“把自己的理念融入到企业里面”的朴素愿望，卢义雄和冯彬彬毅然踏上了创业之路。
卢义雄曾是一名炮兵，退伍后和妻子冯彬彬在同一家电气相关公司工作，“我们一个做采购、一个做销售。”冯彬彬提到，多次外出学习的经历，让他们对这个行业有了更多更深的认识。“想把学来的东西用起来，那就干脆自己干。”卢义雄笑说。主营电力金具、光缆金具、隔离开关等研发、生产、销售的浙江新沃电气有限公司（以下简称“新沃电气”）成为了夫妻俩实现理想的舞台。“创业初期，最大的困难就是资金和客源。”卢义雄回忆道，“最开始的阶段，客户都是自己跑出来的。”他们开着一辆车，穿梭于江苏、河北、山东、山西等地，一趟下来都有六七千公里。
如今再想起那段“晚上开车，白天聊客户”的岁月，已然成为了夫妻俩和新沃电气最珍贵的创业记忆。`},
                    { img: require('../../assets/images/25083004.jpg'), text: `“公司渐渐上了轨道，我们的步子也迈得大起来。”冯彬彬称，新沃电气成功入围国家电网、南方电网等，产品出口古巴、韩国、约旦、印尼等国家。
而成绩单的背后，是企业一以贯之的理念——以人为本。“既是对我们员工的，对我们客户的，也是对这个行业的。”卢义雄称，给员工提供安定的生活和安全的工作环境；做好产品的安全性，“我们产品应用于电力，电力服务于千家万户。看似我们只是做了一个小小的产品，但其质量、安全一定是重中之重。”为此，在企业发展过程中，夫妻俩做出了一个关键决策：持续加大研发，累计投入数百万元的试验费用，不仅体现了他们对产品质量的极致追求，更赢得了客户的深度信任。“客户为什么会把这个单子下给你？是因为相信你。”卢义雄坚定地说，“肯花这个代价去做那么多试验，就代表你愿意把这个产品做好。”`},
                    { img: require('../../assets/images/25083005.jpg'), text: `2023年8月，新沃电气正式入驻海经区。“这里很好，搬过来之后，实实在在地让我们感受到了家的温暖。”冯彬彬称，新沃电气前后经历了5次搬迁，终于在海经区拥有了自己的厂房，并且有计划在这块产业热土上，再购地建新厂扩大生产，“跟海经区结下良缘。”
“特别是到了海经区后，我们对企业的经营理念更好发挥，来的客户也更密集了。”卢义雄笑称，如今他们不用再像以前一样在外面跑，坐在“家”里就有客户、有订单来，“在我们看来，人做好了，产品做好了，服务做好了，对我们企业来说，就是一个最好的广告。”
从白手起家到综合产值过亿，“累并快乐着。”夫妻俩异口同声。十多年的创业路，卢义雄和冯彬彬用执着与热爱，将企业做到了行业佼佼者。“做人要乐观一点，去创业，去做企业也一样，我们要去体会每一个阶段里的快乐。”这种乐观积极的精神，也融入到企业血脉之中，成为新沃电气的一种企业文化。
面对未来，他们展现着坚定的决心，“进入了这个行业，就一心把这个事情做好。不论前方的路途有多遥远，我还是义无反顾地，要把企业上到更新的台阶。”冯彬彬道。`},
                
],
                summarize: ''
            }
        },

        {
            addr: '/news/one',
            date: '2025.08.26',
            title: '霞浦县委书记郭文胜莅临霞浦富轹海洋经济产业园调研重点项目建设情况',
            img: '',
            content: {
                subheading: `8月26日，霞浦县委书记郭文胜率队莅临霞浦富轹海洋经济产业园项目现场，调研重点项目建设推进情况，县领导崔向新、叶丽建参加，县经开区管委会、工信局、住建局、松山街道等领导陪同。项目总经理诸总协团队陪同接待。`,
                data: [
                    { img: require('../../assets/images/25082601.jpg'), text: ``},
                    { img: require('../../assets/images/25082602.jpg'), text: ``},
                    { img: require('../../assets/images/25082603.png'), text: ``},
                ],
                summarize: '调研过程中郭文胜一行先后询问项目建设情况、招商情况和需协调的问题，项目总经理诸总汇报项目目前进展顺利，主体建设接近尾声，已开始附属设施施工，项目按时交付有保障；招商工作同步进行，首批客户已开始由管委会入园审核，即将入驻；随后郭文胜强调，各相关部门和乡镇（街道）要强化服务意识，主动靠前、精准对接，加强沟通协调，及时帮助企业解决项目建设过程中遇到的困难和问题，加快项目建设步伐，为县域经济发展贡献更多力量。'
            }
        },
        
        {
            addr: '/news/one',
            date: '2025.08.11',
            title: '今功机械杨子希：在接力中创新，让“中国智造”走向世界',
            img: '',
            content: {
                subheading: `瓯江口机器人产业园是温州海经区的明星智慧园区，政府和园区通过政策支持和贴心服务不断优化营商环境，提供发展便利，众多企业选择来这里创业发展，蓬勃成长。让我们一起关注和见证这些优秀园区企业的成长历程。
今功机械，主营产品有智能化连帮注射鞋机，智能制鞋生产线等。企业2023年正式入园投产，建筑面积1万㎡左右，并于2024年荣获国家高新技术企业称号。`,
                data: [
                    { img: require('../../assets/images/2508111.png'), text: `在海经区这片充满活力的热土上，每一个厂房的灯火、每一次技术的突破，都藏着民营企业家“热辣滚烫”的奋斗故事，故事里有白手起家的传奇，有技术攻坚的执着，更有政企同心优化营商环境的温暖。“温暖营商・海经故事”专题系列报道将带领大家走进海经区民营企业家的世界，倾听他们在海经区创新创业心声，见证企业与海经区双向奔赴的成长，探寻民营经济蓬勃发展背后的力量。`},
                    { img: require('../../assets/images/2508113.png'), text: `“就在前两天，一台‘大家伙’从这里‘出海’。”站在一台台由自家研发与生产的智能连帮注射鞋机前，浙江今功机械自动化有限公司（以下简称“今功机械”）外贸经理杨子希坚定而又欣喜：“今年我们鞋机的海外销量远超预期。”
从父亲“让中国人用上平价好设备”的初衷，到女儿带着国产鞋机站上国际舞台，今功机械产销量不断攀升的背后，既是跨越代际的接力，也是传统制造业向“中国智造”的蜕变。`},
                { img: require('../../assets/images/2508114.png'), text: `“让中国人用上平价好设备”——这句刻在今功机械基因里的话，源于一段让杨子希父亲杨彬“憋着一口气”的经历。2000年前后，杨彬还在生产劳保鞋，彼时车间里的连帮注射鞋机全靠进口。“一台设备动辄上千万，交期要等一年多，出了故障得停工十几天等国外工程师来修，配件价格更是高得离谱。”杨子希回忆起父亲的早年经历，语气里满是感慨。
正是这份被“卡脖子”的憋屈，杨彬带着“要造中国人自己的鞋机，让中国鞋企用上平价又靠谱的设备”的执念，成立了今功机械。创业初期，团队面对的是“无图纸、无供应链、无成熟技术”的三无困境。“父亲带着老技术员们对着图纸反复测算参数，一头扎进车间研究调试，核心部件的调试不下百次。”
功夫不负有心人。今功机械的第一台样机造出来了，送到温州一家鞋厂试用，当检测数据与国外设备不相上下时，客户当场追加订单；更有客户在复购时说“你们的机器不仅省了成本，更给了咱们制造业自信”。正是这自主研发生产的底气，让今功机械在鞋机领域站稳了脚跟。`},
                { img: require('../../assets/images/2508115.png'), text: `2020年，杨子希研究生毕业，学金融的她顺利进入上海一家证券公司。“可能温州人总有份‘家业情结’吧，听到父亲说公司在外贸领域有‘短板’，我就想还是回来帮他。”
刚入行时，杨子希如一张“白纸”，“对机械一窍不通，对销售毫无经验。对我来说是跨专业，一切从零开始学。”杨子希就从最基础学起，跟着技术员拆机器、记参数，泡在车间里熟悉每一款设备的性能；跟着老销售跑客户、练话术。
如今，她对今功机械的产品如数家珍，更是带着“90后”的闯劲，发挥自己所长，给公司装上“国际引擎”，不断提升其在国际市场的竞争力：积极开展国际检测认证工作；参加国内外各类制鞋行业展会；在多个国外社交平台搭建官网，向全球客户推介产品……“线上线下协同发力，我们逐步构建起了覆盖全球主要制鞋市场的销售网络。”杨子希称。`},
                { img: require('../../assets/images/2508116.png'), text: `“从最初的一款设备，到如今各种各样的产品，我们从不敢停下研发的脚步。”杨子希说，只有用科技“换芯”，产品才能“焕新”，在升级迭代中创造更高的生产效率。如今，今功机械每年将20%~25%的产值投入研发，与多所高校进行产学研合作，送公司员工外出学习进修。
在技术升级的同时，2023年今功机械作为首批入驻企业，整厂搬迁到瓯江口机器人产业园，“新厂房比原来大了很多，车间也更亮堂了，客户来参观时印象分就加了不少。”杨子希笑着说，入驻后的几年，公司产值持续上升，预计今年能创下近5年来的新高。
“对守业的敬畏，对新创的执念。”杨子希称，对于她而言，是在接力中再出发，也因为有父亲给予的有力肩膀，让她更有底气更有胆量，“我要做的是从‘有’到‘优’，带着一群人、一份事业，坚定地走下去，让‘中国智造’去到更广阔的世界。”`},

                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.07.23',
            title: '霞浦富轹海洋经济产业园项目建设有序推进',
            img: '',
            content: {
                subheading: `福建省重点项目——霞浦富轹海洋经济产业园的建设进度一直备受关注。眼下，园区内多栋大楼已顺利封顶，近 300 名工人正分工明确地投入主体施工环节，各项工程稳步推进，目前项目总进度已完成 75%~80%，一幅热火朝天的建设图景正徐徐展开。`,
                data: [
                    { img: require('../../assets/images/2507231.png'), text: `项目规模：137 亩 “海洋食品产业综合体”
    该项目占地面积 137 亩，总建筑面积 18.33 万平方米，总投资 6 亿元。自 2024 年 7 月开工以来，建设团队高效推进工程，目前已完成约 12 万平方米的建筑面积。从规划来看，这里绝非单一的生产厂区 —— 项目聚焦海洋经济特色，将打造集海产品精深加工生产、物流仓储、电商直播及相关配套于一体的综合性海洋食品产业园区，全方位覆盖海洋食品从加工到销售的全链条需求。
运营核心：以 “集群服务” 激活产业潜力
    不同于传统产业园，霞浦富轹海洋经济产业园定位为 “专为海洋食品企业集群服务的制造业平台”，其运营核心牢牢锁定在产业运营、产城融合、资源共享三大方向。这意味着未来入园企业不仅能获得生产空间，更能依托园区的集群优势，实现物流、电商、技术等资源的高效整合，降低运营成本，提升市场竞争力。
未来展望：2026 年交付，预计年总产值 6 亿元
    按照计划，项目将于 2026 年上半年全部完成交付使用。而随着产业园的投用，其经济带动作用也将逐步显现 —— 投产后预计年总产值可达 6 亿元，不仅能为霞浦海洋经济注入新动能，更将推动当地海洋食品产业向规模化、精细化、高附加值方向升级，成为区域产业转型的重要支点。`},
                    { img: require('../../assets/images/2507232.jpg'), text: ``},
                ],
                summarize: ''
            }
        },
         {
            addr: '/news/one',
            date: '2025.07.10',
            title: '临海市中部智能制造产业园8、9#楼喜结金顶',
            img: '',
            content: {
                subheading: ` 2025年7月10日，随着最后一方混凝土浇筑完成，临海中部智能制造产业园8#、9#楼厂房正式封顶。这一里程碑节点标志着园区建设迈入新阶段，也为临海打造长三角南翼智能制造产业标杆注入强劲动能。`,
                data: [
                    { img: require('../../assets/images/2507101.png'), text: `作为临海打造智能制造产业集群的重要载体，该产业园自启动以来便备受关注。此次8#、9#楼厂房结顶不仅是项目建设的重要里程碑，更意味着园区距离“打造集研发、生产、配套于一体的现代化产业高地” 的目标又近了一步，为入驻企业提供优质的发展平台，助力临海智能制造产业高质量发展。`},
                    { img: require('../../assets/images/2507102.jpg'), text: `临海中部智能制造产业园厂房面积在700㎡-7000㎡之间，一层层高7.2米-9米，二层层高4.8米-5.8米，三层以上层高4-4.8米；二层荷载1吨/㎡，三层以上荷载600-800kg/㎡，按需定制企业专属形象。园区规划有宿舍、超市、食堂、咖啡吧、健身图书中心等生活配套，厂门口享受城市生活。`},
                    { img: require('../../assets/images/2507103.jpg'), text: `金顶已成，未来可期！临海中部智能制造产业园正以“每天都是节点”的紧迫感，全力冲刺全面竣工目标。项目8#、9#楼厂房结顶是阶段性胜利，更是新征程的号角！项目将继续以匠心筑品质，以实干促发展，全力推进项目后续建设，期待与您见证更多精彩时刻！`},
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.06.27',
            title: '诚创电子黄蜀东：“夫妻档”白手起家的品质定力',
            img: '',
            content: {
                subheading: `温州市诚创电子科技有限公司于2023年12月入驻机器人产业园，黄蜀东夫妇白手起家，坚守品质核心价值，在轻触开关领域深耕发展，借力产业园平台不断追求卓越领先。`,
                data: [
                    { img: require('../../assets/images/25081103.png'), text: `在海经区这片充满活力的热土上，每一个厂房的灯火、每一次技术的突破，都藏着民营企业家“热辣滚烫”的奋斗故事，故事里有白手起家的传奇，有技术攻坚的执着，更有政企同心优化营商环境的温暖。“温暖营商・海经故事”专题系列报道将带领大家走进海经区民营企业家的世界，倾听他们在海经区创新创业心声，见证企业与海经区双向奔赴的成长，探寻民营经济蓬勃发展背后的力量。`},
                    { img: require('../../assets/images/25081104.jpg'), text: `“每一位客户的信任都来之不易，我们非常珍惜今天所拥有的一切。”回忆起白手起家，创办温州市诚创电子科技有限公司（以下简称“诚创电子”）的来时路，黄蜀东、郑晓月夫妇既感慨又感激。在第二故乡温州的沃土上，他们深耕轻触开关领域，坚持高端品质的核心价值，不断在创业创新的征途上破浪前行。`},
                    { img: require('../../assets/images/25081105.png'), text: `2000年，大学毕业的黄蜀东离开家乡重庆，来到温州发展，开始踏入电子元器件——轻触开关领域。十年耕耘间，他与郑晓月喜结良缘，在原公司的岗位也做到了顶峰，“想更好地施展自己的拳脚，决定创业。”黄蜀东的这个决定，得到了妻子的支持。于是，2010年夫妻俩拿出积攒的工资收入，创办了诚创电子。
    创业之路布满荆棘，“资金和订单，是起步阶段最大的困难。”黄蜀东回忆，头一年回家乡过年的路上，都在想怎么筹钱，幸而一笔及时的信用贷款成了“救命稻草”；遍地撒网推广产品的半年后，实现了从0到1的突破，“拿到第一笔订单的时候，我们俩真的是喜极而泣，感觉比以往经历的任何一个时刻都要激动。”郑晓月称。`},
                    { img: require('../../assets/images/25081106.png'), text: `如今夫妻俩对第一笔订单仍记忆犹新，“来自广东东莞，下单了几十万只，现在看来是很小的一笔，但对当时的我们是多么的可贵。”黄蜀东透露，其实期间，有接触到一笔“大单”——几百万只的体量，但他们断然拒绝了，因为对方走廉价路线，对品质要求低。“一旦做了低端，我们对品质的坚持就可能会动摇。这也是我经常叮嘱员工的。”黄蜀东说，“从创业之初，我们给自己的定位就是做中高端市场，主抓质量，品质是我们公司的核心价值。”
    正是将“品质”刻入企业骨髓，诚创电子在激烈的市场竞争中站稳了脚跟，订单纷至沓来。夫妻俩也越干越有劲，黄蜀东主抓生产技术与产品开发，郑晓月则负责销售与人事管理。“各自专注擅长领域，让经营更高效。”独特的“夫妻档”模式也为企业发展注入稳定力量。`},
                    { img: require('../../assets/images/25081107.png'), text: `2023年12月，诚创电子整体搬迁至海经区，入驻机器人产业园，这里包容的生态和得天独厚的地理位置，为企业带来了全新发展势能。
    从产品研发到材料选择，生产工艺的全自动化布局，再到产品品控的严格把关，在如今的诚创电子生产车间里便可窥见一斑。“看似几毫米的电子元器件，精密度、稳定度都要严控。”为此，黄蜀东不仅每年在研发上投入，还在厂区内打造了占地面积近500平方米的无尘车间，购置了数十台用于裁铆、性能检测、外观检验等工序的自动化器械。
    “向‘轻触开关最优秀制造商’目标扎实迈进，是我们诚创电子的愿景。”黄蜀东称，希望进一步借助海经区产业集聚的平台优势，将企业做大做强。`},

                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.06.19',
            title: '临海市委书记吴华丁深入产业园开展调研指导工作',
            img: '',
            content: {
                subheading: `为加速推进重点项目建设，全力打造产业发展新引擎，6月19日，临海市市委书记吴华丁一行深入临海市中部智能制造产业园，开展实地调研，实地查看项目建设进度，协调解决建设难题，为产业园高质量建成投产保驾护航。`,
                data: [
                    { img: require('../../assets/images/25081101.jpg'), text: `吴华丁书记深入一线，实地考察建设进展情况，详细查看标准化厂房及配套基础设施的建设现状，全面了解产业园的功能分区、产业定位及未来发展规划。他驻足细致询问施工计划及工程质量管控措施，并强调，务必在确保质量和安全的前提下，科学组织施工，倒排工期、挂图作战，确保项目早日建成、投产、达效。`},
                    { img: require('../../assets/images/25081102.jpg'), text: `吴华丁书记一行认真听取了临海市中部智能制造产业园项目总经理叶海敏的工作汇报。在了解到产业园专注于医疗器械、新能源和智能制造领域，致力于打造集研发、生产、销售为一体的现代化产业集群后，吴华丁书记强调，必须立足长远，坚持高标准规划和高质量建设，充分挖掘和利用区位优势和资源禀赋，精准把握产业发展趋势，为区域经济的高质量发展注入强劲动力。
    同时，吴华丁书记对产业园的未来发展寄予厚望。他要求，产业园要坚持“建园”与“聚产”同步推进，提前谋划招商引资工作，围绕主导产业精准招商，引进一批产业链上下游的优质企业，形成产业集聚效应。`},
                ],
                summarize: '此次市委领导调研，为临海市中部智能制造产业园的建设指明了方向、坚定了信心。相信在市委、市政府的坚强领导下，通过各方共同努力，临海市中部智能制造产业园必将早日崛起，成为产业升级的新高地、经济发展的新增长极，谱写高质量发展的辉煌篇章！'
            }
        },
         {
            addr: '/news/one',
            date: '2025.04.27',
            title: '霞浦县委组织部部长许巧清一行莅临霞浦海洋经济产业园',
            img: '',
            content: {
                subheading: `4月27日下午，霞浦县委常委、组织部部长许巧清率队深入霞浦海洋经济产业园调研指导工作，实地考察园区建设进展及招商情况。县经开区管委会领导俞益翔及相关部门负责人陪同。项目负责人高灿携项目团队陪同接待。`,
                data: [
                    { img: require('../../assets/images/2504271.jpg'), text: `   霞浦县委组织部部长许巧清一行莅临霞浦海洋经济产业园调研指导`},
                    { img: require('../../assets/images/2504272.jpg'), text: `   在霞浦富轹海洋经济产业园项目展厅，许巧请一行实地了解项目建设、招商等相关情况，据负责人高灿介绍在县各相关部门的支持下，目前项目进展飞速，开发建设期间遇到问题，经相关部门协调后都快速予以支持和解决，截止2025年4月项目一期封顶面积已达到7.5万平方米，安装工程已陆续进场，附属设施建设已筹备完成，计划8月一期工程全部封顶，目前已招引部分浙江江、宁德等地多家食品相关企业入驻，项目预计2026年初全面交付投产，投产后预计年产值可达5亿元，年贡献税收可达2000万元以上。`},
                    { img: require('../../assets/images/2504273.jpg'), text: `   霞浦经济开发区管委会常务副主任俞益翔向调研组介绍，该项目将严格按照县投资要求，以“精深加工”为核心，打造全链型海洋食品产业园区，规划建设海产品精深加工区、电商直播基地、冷链物流中心、企业孵化平台等功能区，形成拎包入驻式的一站式产业平台，助力县内外入驻企业高质量发展。
   最后，县委常委、组织部部长许巧清强调：海洋经济是霞浦高质量发展的核心，对于新建海洋产业相关园区，主管部门在履行监管职责的同时也要做好企业服务，积极解决项目建设过程中遇到的困难，积极培育来霞企业发展壮大，为县域经济发展做出积极贡献。`},
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.04.15',
            title: '大信智谷应邀率团赴越南考察',
            img: '',
            content: {
                subheading: `4月14日，中共中央总书记、国家主席习近平乘坐专机抵达河内，开启了对越南的国事访问。这是2025年今年中国元首出访开篇之作，也是中央周边工作会议后面向周边的首访。今年恰逢中越建交75周年暨“中越人文交流年”，中越命运共同体建设迎来新的发展机遇。`,
                data: [
                    { img: require('../../assets/images/2504151.jpg'), text: `4月14日，中共中央总书记、国家主席习近平乘坐专机抵达河内，开启了对越南的国事访问。这是2025年今年中国元首出访开篇之作，也是中央周边工作会议后面向周边的首访。今年恰逢中越建交75周年暨“中越人文交流年”，中越命运共同体建设迎来新的发展机遇。`},
                    { img: require('../../assets/images/2504152.jpg'), text: `   习主席出访同日，应越南富成集团邀请，由大信智谷团队率领的的中国企业经贸考察团也抵达越南，就双边经贸和产业开发等合作事宜进行为期三天的考察活动。
   本次组团赴越由浙江富轹科技集团牵头，杭州得贝宠物、温州海螺集团、 浙江中润生态环境治理有限公司、浙江固邦建筑特种技术有限公司、东屋世安物联科技有限公司等国内企业随同考察，受到了东道主越南富成集团的欢迎和热情款待。`},
                    { img: require('../../assets/images/2504153.jpg'), text: `中国自2004年起成为越南第一大贸易伙伴，越南2016年起成为中国在东盟第一大贸易伙伴。中越贸易额已连续四年突破2000亿美元，2024年达2606.5亿美元，同比增长13.5%。越南也是中国在海外重要投资目的地，2024年中国企业对越直接投资超25亿美元。
   本次习主席出访，中越两国发表关于持续深化全面战略合作伙伴关系、加快构建具有战略意义的中越命运共同体的联合声明，双方确认了坚定推进中越友好、提升战略互信，双方同意以中国发展新质生产力、越南发展新型生产力为契机，构建更加广泛深入的全方位合作格局。双方同意开展更加紧密的多边战略协作。
   近年来，中越经贸合作不断加深，重点领域包括农产品贸易、电子制造、纺织加工和跨境物流。经济上，双边贸易额持续增长，中国已成为越南最大的贸易伙伴，越南也是中国在东盟的最大贸易伙伴。越南的榴莲、百香果、海产品大量进入中国市场，中国的手机零部件、光伏材料、工程机械也涌进越南。如今，边境不再是地理分隔，而是友谊桥梁，中越正在共同把“边境线”变成“合作带”。当前中国众多企业都有着积极的出海意向，以寻找新的业务契机和合作发展方向。越南作为东南亚友邻，其政治经济和市场环境不断发展改善，在现下全球贸易格局中有望成为新的投资热土，赢得中国企业的积极关注。`},
                    { img: require('../../assets/images/2504154.jpg'), text: `中越企业家交流会谈`},
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.04.08',
            title: '临海这项工作，被人民日报点赞！',
            img: '',
            content: {
                subheading: `4月2日人民日报刊文《产业落地 创新提速》点赞台州推动产业数字化智能化转型厚植发展新动能以临海中部智能制造产业园开工等为例肯定了临海推动产业数字化、智能化转型的成效`,
                data: [
                    { img: require('../../assets/images/2504081.jpg'), text: `针对传统产业占比超过60%、战略性新兴产业仅占25%的现状，台州市去年初启动了产业平台提能升级工作，努力优化产业结构，培育发展战略性新兴产业。
一年多来，台州市坚持项目为带动，推进招商引资、项目管理、产业培育，不断推动项目向主导产业集中、产业向主平台集聚。截至今年3月底，台州市拥有32个百亿级县域产业集群、73个国家级产业基地、6020家规上企业、2个国家先进制造业集群。`},
                    { img: require('../../assets/images/2504082.png'), text: `为推动产业数字化、智能化转型，台州市临海市持续推进产业平台建设，致力于构建层次分明、协同共进的智能制造产业生态。今年3月底，临海中部智能制造产业园开工仪式举行，将招引高端装备制造、医疗器械、信息技术等新质生产力核心产业落地临海。`},
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.03.28',
            title: '临海中部智能制造产业园开工仪式盛大举行',
            img: '',
            content: {
                subheading: `2025年3月28日，春潮涌动、万物竞发，临海市产业发展迎来里程碑时刻——临海中部智能制造产业园开工仪式在万众瞩目中盛大启幕！`,
                data: [
                    { img: require('../../assets/images/2503282.jpg'), text: `   临海市委书记吴华丁，临海市委常委、组织部部长陈建波，临海市委常委、副市长宋江涌，临海市人大常委会副主任李强，临海市政协第十五届委员会党组成员、副主席卢才超，香港宾盛国际集团有限公司董事局主席叶晓平，瑞洲建设集团有限公司负责人孙士金等嘉宾共同挥锹培土，为这一“智造引擎”奠基启航。`},
                    { img: require('../../assets/images/2503283.jpg'), text: ``},
                    { img: require('../../assets/images/2503284.jpg'), text: ``},
                    { img: require('../../assets/images/2503285.jpg'), text: `   香港宾盛国际集团董事局主席叶晓平致辞：临海中部智能制造产业园将依托集团在装备制造、医疗器械、信息技术等领域的资源优势，打造集研发生产、检测检验、总部办公、创新创业孵化于一体的科技现代化产业高地。`},
                    { img: require('../../assets/images/2503286.jpg'), text: `   临海市委常委、副市长宋江涌表示，宾云科技要严格工期管控，确保项目早日建成投产。同时，也希望市级各有关部门全力服务、优化保障，助推项目加速推进，要主动靠前、强化落实，共同为项目顺利推进提供坚实支撑。`},
                    { img: require('../../assets/images/2503287.jpg'), text: `   此刻的携手，是信任的凝聚，更是共赢的启航!江西三华控股发展集团有限公司、恒邦数科集团、云翼超算（北京）软件科技有限公司、新华三集团、云南栢田医疗科技有限公司、浙江雷亚科技有限公司将携手临海中部智能制造产业园共绘未来发展蓝图！`},
                    { img: require('../../assets/images/2503289.jpg'), text: `   数字化浪潮奔涌向前，智慧赋能产业升级！浙江省常青藤生命科学与物理化学研究院、杭州盘兴科技产业发展有限公司、飞鹿云计算有限公司赋能产业园，打造“信息化、数字化、智能化”标杆园区！`},
                    { img: require('../../assets/images/25032810.jpg'), text:`   产业兴则金融兴，金融活则产业活！临海中部智能制造产业园携手临海农商银行城东支行、中信银行临海支行，为企业的发展提供金融支持。`},
                ],
                summarize: '   今日的培土奠基、战略合作，是梦想的播种，更是未来的启航！我们坚信，在临海市政府的引领下、在合作伙伴的支持下、在各界朋友的关注下，临海中部智能制造产业园必将成为产业升级的引擎、科技创新的高地、人才汇聚的热土！'
            }
        },
         {
            addr: '/news/one',
            date: '2025.02.08',
            title: '海经区领导新春走访机器人产业园',
            img: '',
            content: {
                subheading: `海经区领导莅临我司走访慰问，助力企业"开门红"`,
                data: [
                    { img: require('../../assets/images/2502111.jpg'), text: `  2月8日，海经区党工委副书记、管委会常务副主任谢忠诚，海经区财政局局长金连昆、海经区经信和科技人才局局长曾开勇等领导一行莅临园区开展新春走访慰问，向公司及入园企业送来新春祝福与问候。`},
                    { img: require('../../assets/images/2502112.jpg'), text: `走访中，谢主任一行详细了解园区企业复工复产情况，重点听取入园企业在经营发展、市场开拓、人才招引等方面遇到的发展诉求，对相关问题现场协调支招。他表示，海经区将持续优化营商环境，通过"政策直通车""服务专员制"等创新举措，精准对接企业需求，全力支持园区企业抢抓一季度"开门红"。`},
                    { img: require('../../assets/images/2502113.jpg'), text: `新春伊始，海经区领导不仅送来了新春慰问，更传递了“政企连心、共谋发展”的强烈信号，既提振了企业发展信心，也为园区产业集群发展注入强劲动能。新的一年，公司以更饱满的热情投入工作，推动园区企业高质量发展，为区域经济发展贡献更多力量。`},
                ],
                summarize: ''
            }
        },
         {
            addr: '/news/one',
            date: '2025.02.08',
            title: '越南富城集团代表访问大信智谷',
            img: '',
            content: {
                subheading: `2月8日，越南富城集团中国区首席代表宋靖一行拜访大信智谷，受到富轹集团管理层的热情接待。温州海螺集团副总经理柯尔克陪同考察。`,
                data: [
                    { img: require('../../assets/images/2502101.jpg'), text: `    来宾参观考察了大信智谷开发的瓯江口机器人产业园，双方就越南工业地产开发和中国企业出海咨询服务等事宜进行了深入交流，并对推进双方进一步合作进行了部署和展望。`},
                    { img: require('../../assets/images/2502102.jpg'), text: ``},
                    { img: require('../../assets/images/2502103.jpg'), text: ``},
                    { img: require('../../assets/images/2502104.png'), text: ``},
                ],
                summarize: '越南富城集团股份公司（PHUTHANH GROUP  JOINT STOCK COMPANY），成立于2012年2月，越南太平省龙头企业集团，创始人吴文发先生，在越南能源产业与土地开发领域成就斐然。集团于能源领域重点布局矿山产业，业务涵盖矿石与石油的零售与批发，在土地开发层面，一级开发与二级开发双轨并行，齐头并进，成为集团发展的重要引擎与坚实支柱，为地区经济的繁荣注入着强劲动力。'
            }
        },
         {
            addr: '/news/one',
            date: '2025.01.23',
            title: '霞浦富轹海洋经济产业园列入2025年福建省重点项目',
            img: '',
            content: {
                subheading: `1月23日福建省发改委印发通知确定2025年度省重点项目1550个总投资4.3万亿元年度计划投资7150亿元霞浦富轹海洋经济产业园列入省重点项目`,
                data: [
                    { img: require('../../assets/images/2501251.jpg'), text: `1月23日
福建省发改委印发通知
确定2025年度省重点项目1550个
总投资4.3万亿元
7150亿元
霞浦富轹海洋经济产业园
列入省重点项目`},
                    { img: require('../../assets/images/2501252.png'), text: `<a href="https://mp.weixin.qq.com/s/3UHI00gGsU0EiDH_ye0Z9Q" target="_blank">2025年度省重点项目名单（1550个）</a>
（点击上方链接查看↑）
`},
                    { img: require('../../assets/images/2501253.png'), text: `各设区市人民政府、平潭综合实验区管委会，省管重点项目各分级管理单位：

　　经省政府同意，确定2025年度省重点项目1550个，总投资4.3万亿元，年度计划投资7150亿元。
　　各级各部门要坚持以习近平新时代中国特色社会主义思想为指导，深入贯彻党的二十大和二十届二中、三中全会精神，贯彻落实习近平总书记在福建考察时的重要讲话精神，按照中央经济工作会议精神，认真落实省委十一届六次、七次全会和省委经济工作会议部署要求，充分发挥省重点项目建设在稳增长、促投资中的“压舱石”作用。狠抓项目建设，强化服务保障，加强项目储备，以问题为导向，坚持集中协调和日常跟踪协调相结合，持续发挥省政府月度协调会、“重中之重”推进制度、重点项目例会推进制度作用，千方百计帮助项目提速建设；落细落实分级管理抓项目，提级跟踪推进各地市重点项目盘子中亿元以上重大项目，对标目标任务，落实工作责任，细化推进举措，及时解决项目推进中存在的困难和问题，确保项目投资进度、质量安全、生态环保同步推进；部门联动要素保障，落实省重点项目资金、用地、用林、用海等需求；深化拓展“深学争优、敢为争先、实干争效”行动，以深学敢为实干的担当作为奋勇争先，以争优争先争效的实绩实效再上台阶，扎实推进重点项目建设，为积极扩大有效投资，夯实经济发展基础提供有力支撑。

福建省发展和改革委员会
2025年1月22日`},
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.01.06',
            title: '富轹集团考察中化学华陆新材',
            img: '',
            content: {
                subheading: `2025年1月6日，富轹集团赴重庆考察了中化学华陆新材料有限公司，受到了华陆新材团队的热烈欢迎和热情接待。`,
                data: [
                    { img: require('../../assets/images/251061.jpg'), text: ``},
                    { img: require('../../assets/images/251062.webp'), text: `中化学华陆新材料有限公司是中国化学旗下专注于新材料研发和生产的高科技企业，于重庆市长寿经济开发区投资40亿，建设了中国领先的纳米级气凝胶复合材料的研发和生产基地。`},
                    { img: require('../../assets/images/251063.webp'), text: `富轹集团考察团队参观了华陆新材的展厅，详细地了解和体验了公司气凝胶产品的独特性能。在此后的交流座谈会上，主客双方围绕气凝胶产品的商业化应用展开了积极和充分的讨论，并在应用场景开拓，产品研发的合作等方面达成了高度的共识。`},
                    { img: require('../../assets/images/251064.webp'), text: `此次考察富有成果。双方合影留念，期待进一步的深入交流和合作。`},
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2025.01.03',
            title: '临海中部智能制造产业园招商中心盛大开放',
            img: '',
            content: {
                subheading: ` 1月3日上午，临海中部智能制造产业园招商中心在万众瞩目中盛大开放，标志着该项目正式踏上新征程，为临海市经济的蓬勃发展注入澎湃动力与崭新活力。`,
                data: [
                    { img: require('../../assets/images/251031.png'), text: ``},
                    { img: require('../../assets/images/251032.png'), text: `临海中部智能制造产业园总经理叶海敏在盛典中致辞，园区将秉持精工匠心，雕琢高品质产业园区，并提供全方位优质服务。未来，园区将以海纳百川的胸怀和互利共赢的理念，全力优化营商环境，深度整合产业上下游资源，成为企业茁壮成长的沃土，携手共创临海中部智能制造产业的璀璨明天。`},
                    { img: require('../../assets/images/251033.png'), text: `祥狮舞动瑞气盈，点睛之笔启新程。瑞狮欢腾跳跃，舞出吉祥如意，将开放仪式的氛围推向高潮，每一个灵动的步伐都寓意着产业园未来的蓬勃发展与无限活力，为这片产业新地标注入了灵魂与朝气。`},
                    { img: require('../../assets/images/251034.png'), text: `在全场嘉宾的共同见证下，香港宾盛国际集团董事·浙江富轹科技集团执行总裁汪振勇、临海中部智能制造产业园总经理叶海敏、台州市温州商会临海分会会长陈汉孟、临海农商银行城东支行行长周宇、台州正邦家居科技有限公司总经理娄剑波一同为招商中心剪彩揭幕，宣告项目翻开全新一页。`},
                    { img: require('../../assets/images/251035.png'), text: ``},
                    { img: require('../../assets/images/251036.jpg'), text: `随后，各位领导与嘉宾满怀期待地步入展厅，深入探寻产业发展脉络。从前沿的产业服务体系，到独具优势的产品规划，再到园区建设的斐然成果，每一处细节都彰显着园区的实力与匠心。嘉宾们对园区在产业融合、人才汇聚、资源集约利用、一站式服务创新等方面给予高度评价，入园企业的品牌矩阵与创新产品展示更让大家对园区的未来充满信心，这里不仅是产业的集聚地，更是创新与梦想的孵化摇篮，引领着临海智能制造产业迈向新高度，书写时代新篇。`},
                    { img: require('../../assets/images/251037.webp'), text: ``},

                ],
                summarize: ''
            }
        },
         

         {
            addr: '/news/one',
            date: '2024.12.31',
            title: '中信海直与集团领导考察低空经济产业',
            img: '',
            content: {
                subheading: `年终岁末，中信海直战略投资总监刘金龙，由浙江富轹科技集团领导陪同，参观考察了建德航空小镇、建德千岛湖通用机场、浙江省低空飞行服务中心等机构和企业，就低空经济产业的战略资源对接、技术合作及产业服务等进行了初步调研和意向沟通。`,
                data: [
                    { img: require('../../assets/images/2412310.jpg'), text: ``},
                    { img: require('../../assets/images/2412311.webp'), text: '' },
                    { img: require('../../assets/images/2412312.webp'), text: '2024年可谓低空经济发展元年，作为一种新兴的综合性经济形态，国家给予低空经济极高的定位，工信部等部门明确了一系列发展目标，各地力争成为低空经济的“头雁”，资本如群蜂逐蜜涌现于低空经济产业链。' },
                    { img: require('../../assets/images/2412313.webp'), text: '在产业链终端，实际应用如百花齐放，低空经济触角伸向物流配送、农林植保、交通接驳等众多场景，正渐渐走向成熟。' },

                ],
                summarize: '大信智谷作为集产业导入、投资，园区规划、开发、运营于一身的新兴的产业全链服务品牌，在以往项目运作成功经验和良好合作的基础上，与中信海直等战略合作伙伴积极协作，借助其国内低空经济的龙头地位和平台运营等优势，力争在这一产业赛道开辟新的发展机遇和增长点。'
            }
        },
        {
            addr: '/news/one',
            date: '2024.12.30',
            title: '富轹科技集团邀请马来西亚总商会MPM考察温州',
            img: '',
            content: {
                subheading: `2024年12月30日，马来西亚总商会MPM秘书长Hasan Mad拿督、马来西亚中小企业发展部代表Faridah A Jabbar拿督、一带一路非政府组织联盟主席Hoo Keng Wai博士和MPM组织相关成员，考察温州海经区、温州湾新区，并与温州市投资促进局进行座谈。浙江富轹科技集团领导全程陪同考察。`,
                data: [
                    { img: require('../../assets/images/2412301.jpg'), text: `代表团第一站考察温州市综合保税区，综保区负责人详细介绍了园区定位、保税模式、发展目标、跨境电商全球购等，并提议马来西亚与中国的双子园可以落户在综保区。在海经区数字展馆，代表团全面了解了温州海经区的发展情况，对海经区短短十年间形成如今的产业规模表示敬佩，并希望下阶段能与海经区深入交流，推动两国间的产业合作。`},
                    { img: require('../../assets/images/2412302.webp'), text: ``},
                    { img: require('../../assets/images/2412303.webp'), text: ``},
                    { img: require('../../assets/images/2412304.webp'), text: `在瓯江口机器人产业园，代表团参观了机器人博物馆，并饶有兴致地和园区负责人交流了智能制造、人才培训等方面合作意向。`},
                    { img: require('../../assets/images/2412305.webp'), text: ``},
                    { img: require('../../assets/images/2412306.webp'), text: ` 30日下午，在温州湾新区投促部门的陪同下，代表团参观考察了瓯飞工程、中国眼谷，既目睹了温州填海工程“沧海变桑田”的壮举，又现场感受了温州围绕“眼睛”而打造的庞大的上下游产业链。`},
                    { img: require('../../assets/images/2412307.webp'), text: `代表团在温州市人民政府和市投促局进行了座谈交流，徐海严局长，项晓副局长，海经区、温州湾新区、瑞安市、综保区的招商部门负责人参加了座谈。座谈会上，MPM组织Hasan秘书长、一带一路联盟何主席、马来西亚BARAKAH基金代表Gilbert先生，就拟投资的中国-马来西亚双子产业园、HALA认证中心建设进行了详细的介绍，双方取得深入的共识，并计划下阶段进一步推动项目的考察、筹备工作。`},
                    { img: require('../../assets/images/2412308.webp'), text: `富轹科技集团积极配合国家“一带一路”发展和企业对外发展的需要，其产业地产品牌大信智谷与海外合作伙伴积极展开战略性布局。应对日益扩张的地缘政治影响，大信智谷开始在一带一路沿线数个重点城市成立办公室，开始筹建当地双城产业园，有利国内产业在新市场发展、也有利海外企业扩展中国巨大的消费市场。`},

                ],
                summarize: '大信智谷凭借多年海外项目的合作经验，主动加强与政府机构、金融资本、工程服务、运营管理、咨询设计、科技研发等各类高端资源的对接合作，提升资源整合能力，为跨国合作创造先决条件。'
            }
        },
        {
            addr: '/news/one',
            date: '2024.12.25',
            title: '青海海东市政府代表团考察富轹集团与中科院浙江应用研究院',
            img: '',
            content: {
                subheading: `12月25日，青海省海东市工业和信息化局领导李元林、乐都工业园领导尕藏加等一行，莅临浙江富轹科技集团考察交流。`,
                data: [
                    { img: require('../../assets/images/2412251.jpg'), text: ``},
                    { img: require('../../assets/images/2412252.webp'), text: ``},
                    { img: require('../../assets/images/2412253.webp'), text: ` 来宾参观考察了富轹科技及旗下示范园区瓯江口机器人产业园，就智能制造和科技园区运营服务、科技赋能等进行了深入了解和沟通。`},
                    { img: require('../../assets/images/2412257.webp'), text: `集团领导还陪同来宾前往浙江中科应用技术研究院，就未来在新材料、新能源、新智造领域的合作进行了充分的交流和探讨。`},
                    { img: require('../../assets/images/2412258.webp'), text: ``},
                    { img: require('../../assets/images/2412254.webp'), text: ``},
                    { img: require('../../assets/images/2412255.webp'), text: `青海省海东市，因位于青海湖以东而得名，是内地进入青藏的咽喉要地，2016年被列为第三批国家新型城镇化综合试点地区。海东资源丰富，是青海重要的能源基地，西电东送的通道。`},
                    { img: require('../../assets/images/2412256.webp'), text: `乐都工业园是青海省装备制造工业园的分园区，其中北区以大型精密铸锻制作为核心，发展铸锻产业，配套发展装备制造、汽车工业、航空航天、核工业、电力工业的基础配套产品；西区主要发展玻璃制品、PVC产品、镁合金精深加工等重点产业。`},
                ],
                summarize: '富轹科技集团在国家产业战略西进的大背景下，以积极态度与西部地方政府对接。大信智谷品牌将发挥自身全链条服务优势，充分整合及调动各类资源，导入智能制造、新材料等先进技术IP，引入优质资本，并提供智能化的园区运营管理。未来将着力强化政企合作，为西部产业振兴发挥积极作用。'
            }
        },
         {
            addr: '/news/one',
            date: '2024.11.15',
            title: '霞浦县政府领导调研视察富轹海洋经济产业园',
            img: '',
            content: {
                subheading: `2024年11月15日上午，霞浦县政府罗义春县长一行莅临霞浦富轹海洋经济产业园开展重点项目调研活动，县工业项目建设领导小组、县工信局、松山街道、县自然资源局、经开区管会等相关部门领导陪同，浙江富轹科技集团总裁携项目总经理陪同接待。`,
                data: [
                    { img: require('../../assets/images/2411151.jpg'), text: ``},
                    { img: require('../../assets/images/2411152.webp'), text: '在项目展厅，县长罗义春与园区负责人进行了深入交流，详细了解园区发展规划、产业布局、建设情况和现阶段困难等情况，罗县长强调，霞浦富轹海洋经济产业园是霞浦县推动海洋经济发展的重要引擎，各相关部门要做好服务，保障项目有序建设。' },
                    { img: require('../../assets/images/2411153.webp'), text: '在项目施工现场，县长罗义春一行实地了解园区建设进度，工期计划和投入情况，并针对项目目前遇到的困难，进行了实地考察、向相关部门了解情况后及时予以协调和解决。' },
                ],
                summarize: '罗义春县长强调，要加快项目周边交通等配套设施的规划建设，为企业发展创造良好的基础保障，帮助项目顺利推进，同时督促项目建设方要抢抓施工黄金期，全力冲刺施工进度，保证项目尽早建成投产，为推动县海洋经济高质量发展注入新的活力。'
            }
        },
        {
            addr: '/news/one',
            date: '2024.10.27',
            title: '宁德市委市政府工作检查组莅临霞浦富轹海洋经济产业园',
            img: '',
            content: {
                subheading: `2024年10月27日，福建省宁德市人大常委会党组书记、主任王世雄一行率领宁德市委市政府工作检查组走进霞浦县，在霞浦县委书记郭文胜等领导干部的陪同下，检查组一行抵达霞浦富轹海洋经济产业园进行了考察调研，检查项目招商、建设等情况。`,
                data: [
                    { img: require('../../assets/images/2410271.jpg'), text: `浙江富轹科技集团领导与霞浦项目负责人接待了各位来访领导，并向检查组一行详细介绍了项目的总体规划、建设意义、建设进展及招商运营现状等。`},
                    { img: require('../../assets/images/2410272.webp'), text: '在项目现场，宁德市委市政府工作检查组一行详细了解项目建设背景、建设情况、招商情况等，与项目负责人进行现场交流，据汪总介绍霞浦富轹海洋经济产业园作为市县海洋经济发展的重要载体，在较短的时间内实现了从无到有、从小到大的跨越式发展，集团将充分发挥自身优势，积极盘活低效用地、招引优质企业、提升亩均产出、活跃区域经济，为霞浦海洋经济产业集聚化发展打造一张新名片，听取汇报后宁德市人大常委会党组书记、主任王世雄表示要大力发展新质生产力、大力支持海洋经济，对于重点项目要积极解决企业遇到的困难，加大对企业的支持力度。' },
                ],
                summarize: ''
            }
        },

        {
            addr: '/news/one',
            date: '2024.09.11',
            title: '瓯江口机器人产业园首届业委会成立',
            img: '',
            content: {
                subheading: `2024年9月，在这个收获的季节里，对大信智谷运营的瓯江口机器人产业园来说是一个具有重大意义的时刻——机器人产业园首届业主委员会正式成立。历经两三个月的精心筹备，在当地政府的关心和指导下，业主们的积极响应、踊跃参与，顺利选举出首届业主委员会。`,
                data: [
                    { img: require('../../assets/images/249111.jpg'), text: `业主大会选举计票
业主委员会的成立，标志着我们机器人产业园的园区管理进入了一个新的阶段。它将代表着广大业主的利益，为大家发声，成为业主与园区管理方之间沟通的桥梁和纽带。`},
                    { img: require('../../assets/images/249112.webp'), text: 
                    `首届业委会第一次会议
未来，业主委员会将积极履行职责，致力于提升园区的管理水平和服务质量。在设施维护方面，将督促管理方及时对园区内的基础设施进行维修和更新，确保大家的工作环境安全、舒适。在环境改善方面，将推动园区的绿化、美化工作，打造一个更加宜人的工作空间。在安全保障方面，将加强对园区的安保管理，为业主们的财产和人身安全提供有力保障。同时，业主委员会也将积极组织各类活动，增进业主之间的交流与合作。通过举办技术交流、行业研讨会等活动，促进园区内企业的共同发展。` },
                ],
                summarize: '我们相信，在首届业主委员会的带领下，机器人产业园将迎来更加美好的明天。让我们携手共进，为打造一个更加繁荣、和谐、创新的机器人产业园而努力奋斗！'
            }
        },
        {
            addr: '/news/one',
            date: '2024.08.26',
            title: '富轹集团与中沙经济发展委员会战略合作',
            img: '',
            content: {
                subheading: `具有多年国际项目管理经验的浙江富轹科技集团有限公司，邀请到中沙经济关系发展委员会副主席，Nabil Y. Al-Kurashi 教授，及Faiz Y. Al-Kurashi 先生，代表沙特政府工业部，于8月20日至24日，来温州考察中国轻工业在自动化进程的发展。几天的紧密行程，考察了君浩电子、法派服饰、德赛集团鞋业等企业。就未来沙特阿拉伯工业自动化，富轹科技集团与沙特来宾进行了深入的交流和讨论，期待在未来工业自动化等领域双方能够开展紧密合作。`,
                data: [
                    { img: require('../../assets/images/2408241.webp'), text: `富轹集团与沙特来宾第一站到访君浩电子，考察调研自动化生产线在质量、效率、与系统化管理。`},
                    { img: require('../../assets/images/2408242.webp'), text: 
                    `沙特来宾到访法派服饰，参观了自动化生产车间，高度评价了自动化工业流程对非标准产品的管理，以及如何提高质量监控、工作效率、和对生产流程的管理。` },
                    { img: require('../../assets/images/2408243.webp'), text: '' },
                    { img: require('../../assets/images/2408244.webp'), text: '访问德赛集团，考察了精度设备对产品生产的改善，以及由人手密集工序到自动化生产的变换流程。' },
                    { img: require('../../assets/images/2408245.webp'), text: '' },
                    { img: require('../../assets/images/2408246.webp'), text: '作为东道主，富轹科技集团盛情接待并邀请沙特来宾考察了自动化多层停车设备，探讨了沙特阿拉伯利雅得、吉达、麦加等重要城市在停车管理上面对的压力和改善方法。宾主双方还就与智能工厂的需求对接进行了深入交流，在中东市场的合作交换了有价值的意见。' },
                    { img: require('../../assets/images/2408247.webp'), text: '' },
                    { img: require('../../assets/images/2408249.webp'), text: '最后，沙特来宾还拜访了温州海洋经济发展示范区管委会，就温州的优质产品在中东地区的合作和销售、以及工业投资事宜，双方进行了深入且有意义的交流。' },

                ],
                summarize: '今年，一系列地缘政治动荡事件冲击着全球经济和资本市场，中美之间战略竞争驱动，主要经济体的供应链政策转向国家优先，成本、效率等方面的经济因素被弱化。 在经济下行的压力下，国内企业“卷的程度”是出乎意料的大，同时出现“出海的速度”，或者说产业外溢的速度，超出了市场的预期。面对强大的市场压力，“必须要开拓‘无中生有、另辟蹊径’的产品、市场，才能跟上世界的变化步伐。”。面对同样经济变化的沙特阿拉伯，也在开拓石油化工以外的新发展动力，沙特阿拉伯和中国，两个相隔一万公里的命运共同体，这次因为工业发展而碰撞在一起。'
            }
        },
        
        {
            addr: '/news/one',
            date: '2024.08.10',
            title: '学习全会精神，共振·同频·齐心',
            img: '',
            content: {
                subheading: `8月10日，富轹科技集团在温州开展夏季团建及业务学习活动。`,
                data: [
                    { img: require('../../assets/images/news248101.webp'), text: `集团战略总监祖恺先生主题演讲解读三中全会精神`},
                    { img: require('../../assets/images/248103.webp'), text: 
                    `温州道盛会计师事务所王老师主讲税务专业知识` },
                    { img: require('../../assets/images/248104.webp'), text: '汪总主讲半导体专业知识及行业发展' },
                ],
                summarize: '本次团建以学习二十届三中全会精神为主题，帮助企业全员把握新的时代格局，强化战略共识，充分理解进一步全面深化改革、推进中国式现代化的重大意义和总体要求。通过解读党的重大会议精神，结合企业经营实践，鼓励员工立足本职，振奋精神积极向上，与国运共振、与政府同频、与公司齐心，克服困难创新求变，抓住机遇续创辉煌。 本次团建活动同时组织了两场全员专业学习。邀请了行业专家为员工宣讲了财税专业基础知识和半导体专题知识，旨在完善知识体系、提升员工专业技能和综合素质。'
            }
        },
        {
            addr: '/news/one',
            date: '2024.08.02',
            title: '霞浦海洋经济产业园开工奠基',
            img: '',
            content: {
                subheading: `8月2日，霞浦海洋经济产业园开工奠基仪式隆重举行。霞浦县委书记郭文胜、原温州市人民政府副市长章方璋、霞浦县人民政府副县长郑金思、霞浦县人大党组成员王永杰、霞浦县工信局、经开区管委会、住建局、自然资源局、工业办、商务局、发改局、松山街道、海洋渔业局、农业农村局、县供电公司各相关部门领导及特邀嘉宾马来西亚工商联（MPM）食品委员会、温州瓯海区农业龙头企业协会、浙江富轹科技集团总裁汪振勇，各银行与企业代表等共同参加本次开工奠基仪式。`,
                data: [
                    { img: require('../../assets/images/240802.jpg'), text: `开工仪式上集团负责人在致辞中表示，霞浦富轹海洋经济产业园的顺利动工，离不开霞浦县各政府相关部门的支持和县优良的营商环境基础，该项目是富轹携手霞浦共谋“海洋经济高质量发展”的良好开端。霞浦富轹海洋经济产业园项目是集团入驻福建发展省外业务的重要开端，项目建成投产后预计年产值可达5亿元，对地方经济发展有积极的推动作用；结合集团自身优势，秉承数字赋能打造科技兴海示范基的建设目标，我们将全力推进项目高标准建设，在霞浦优良的海洋食品产业基础上精准延伸水产品精加工、自主品牌树立等重要环节，将产业链进一步做大做强，努力为入园企业提供更优质的生产、升级、金融、创新服务，为霞浦海洋经济发展贡献自己的力量！`},
                    { img: require('../../assets/images/2408022.webp'), text: 
                    ` 霞浦县人民政府副县长郑金思对项目开工奠基表示热烈祝贺。致辞中郑副县长表示：绵长的海岸线和众多的岛屿、港湾形成独特的地理结构，孕育了丰富的海洋渔业资源，霞浦具有“中国海带之乡”“中国紫菜之乡”“中国南方海参之乡”“中国生态大黄鱼之乡”“中国海带苗之乡”等金字招牌，是名副其实的“千鲜之城”。霞浦富轹海洋经济产业园的顺利开工，为我县低效用地高质量发展树立了典范，具有显著的社会效益与经济效益。浙江富轹科技集团的积极投资与建设，为霞浦县海洋食品产业链的全面发展注入了强劲动力，在此我们希望富轹能够坚持高标准、高质量的建设目标，并积极开展招商引资工作，带领更多的优质企业共同推进霞浦海洋经济高质量发展目标。` },
                    { img: require('../../assets/images/2408023.webp'), text: '盛世良辰兴大业，鹏程万里更辉煌。开工奠基吉时到来，现场掌声如雷，礼炮齐鸣，霞浦县委书记郭文胜带领县各相关部门领导共同为奠基仪式挥铲培土，标志着霞浦富轹海洋经济产业园项目圆满开工，开启新的篇章！' },
                    { img: require('../../assets/images/2408024.webp'), text: '强强联合促发展，携手共进谱新篇。本次活动中也见证了项目前期的招商成果和富轹集团优秀的战略合作单位集群，马来西亚工商联（MPM）食品委员会、温州瓯海区农业龙头企业协会、百珍堂、温州永高食品、宁波农心水产、宁德源畅、浙江海味鲜、苍南福顺水产等企业与霞浦富轹海洋经济产业园集中签署项目投资合作协议。双方将以此次签约为契机，进一步深化全方位、深层次、的合作，加快推动霞浦海洋经济高速发展，共逐海洋经济领域新蓝海。' },
                    { img: require('../../assets/images/2408025.webp'), text: '浙商银行、兴业银行作为园区金融战略合作单位，为入园企业提供按揭贷款、经营贷款、仓单贷款等全链金融服务。飞鹿云计算温州有限公司充分发挥阿里云工业互联网的优势，聚集数字化、智能化资源，赋能入园企业。霞浦寰宇电商物流园作为园区电商物流运营战略合作单位，为入园企业提供电商运营、快递物流等全方位优质电商服务。福建博槐环境科技有限公司作为园区环保服务战略合作单位，为入园食品加工企业提供环保处理全流程解决方案。' },

                ],
                summarize: ''
            }
        },

        {
            addr: '/news/one',
            date: '2024.07.09',
            title: '乘“云”向未来，飞鹿云助力温州企业高质量发展',
            img: '',
            content: {
                subheading: ` 7月9日，温州市经济和信息化局官网发布了《2024年温州市智能化技改咨询（培训）服务机构》，飞鹿云计算（温州）有限公司连续多年再次上榜。`,
                data: [
                    { img: require('../../assets/images/news247121.png'), text: `飞鹿云是浙江富轹科技集团依托阿里云工业互联网技术落地温州的云服务平台。
飞鹿云计算（温州）有限公司作为阿里云温州市工业互联网平台的运营平台，系浙江省新智造公共服务应用平台首批入库供应商，并已取得各项专利和软著证书数十项。基于温州传统企业的数字化升级和上云需求，飞鹿云将以阿里云企业数字化系列产品为温州企业数字化的高质量发展提供支持和服务。`},
                    { img: require('../../assets/images/news24712.webp'), text:`7月12日，温州国际云软件谷项目签约活动暨AI赋能产业发展沙龙在温州国际云软件谷举行。会上正式发布的温州市“十朵云”项目尤为引人瞩目。
温州市副市长毛胤强，龙湾区区长夏禹桨，以及市经信局、市科技局、市数据局相关领导等出席活动。阿里、华为、百度、科大讯飞、紫东太初等行业头部企业专家，相关高校、企业、飞鹿云代表等齐聚一堂，共商温州产业高质量发展，共绘数据生态创新蓝图。
期间，温州重磅发布国内首创的“十朵云”平台。“十朵云”是一个汇聚了阿里云、华为云、天翼云、移动云、联通云等十个国内顶尖云服务提供商的综合性云服务平台。为持续深化企业上云用数赋智，加快推动企业数字化转型，温州市汇聚多家知名云服务提供商，整合各类云服务资源，为企业用户提供一站式的云化集成服务，包括详细的云服务信息、专业的咨询和评估服务、完善的售后服务等等，助力企业轻松上云和高效管理。
据悉，“十朵云”项目落地后，各服务商将在国际云软件谷设立专业服务团队，为潜在客户提供云服务选择、配置等方面的咨询服务，为存量客户解决上云用云过程中遇到的问题。同时聚焦温州特色优势制造业和战略性新兴产业，持续梳理并定期更新发布云服务机会清单和“十朵云”能力清单。`},
                    { img: require('../../assets/images/news247122.webp'), text: '当日下午，“十朵云”供需对接会也成功举办，近百家制造企业与服务商达成数字化转型合作意向。由政府牵线搭桥，企业精准对接、携手上“云”，以数字化转型升级推进新型工业化。' },
                ],
                summarize: '下一步，飞鹿云将进一步加强温州企业的服务对接，同时不定期举办主题沙龙、培训、推介等活动，加深企业对云计算、数字化、人工智能等新一代信息技术的理解，为企业提供更全面、深入的技术指导和服务，欢迎有需要的企业和部门咨询接洽。'
            }
        },
        {
            addr: '/news/one',
            date: '2024.02.26',
            title: '温州海经区领导调研瓯江口机器人产业园',
            img: '',
            content: {
                subheading: `2月26日，温州海经区党工委书记、管委会主任徐建兵一行在瓯江口机器人产业园进行了走访调研。`,
                data: [
                    { img: require('../../assets/images/news2402298.jpg'), text: `徐建兵书记十分关心机器人产业的发展。在园区内，他仔细询问了企业入驻情况，了解企业生产经营中遇到的难题，还深入已入驻的浙江斯普威尔电气有限公司，察看企业车间生产情况。针对企业提出的人才引进难、园区配套未完善等问题，并叮嘱有关部门要主动对接、靠前服务，精心呵护机器人这一被誉为“制造业皇冠顶端的明珠”的产业；同时，要加快科技创新，提升高端制造业水平，为海经区经济社会发展注入强力动能。
徐书记强调，要深入学习贯彻习近平总书记考察浙江重要讲话精神，认真落实全省、温州市和海经区“新春第一会”精神，坚持以营商环境优化来激发活力、以作风建设破题开局，实现政企同心、双向奔赴，以精准化服务助力企业高质量发展，奋力开创平台建设新局面。`},
                    { img: require('../../assets/images/news2402299.jpg'), text: 
                    `海经区管委会领导周海波、陈楠、吴晨宇等参加了走访调研。` },
                    { img: require('../../assets/images/news24022910.png'), text: '温州瓯江口机器人产业园项目总建筑面积62万平方米，被列为浙江省“152”重点产业项目，总投资25亿元。园区建有机器人研发和生产基地、机器人应用示范区、机器人博物馆及配套工程，形成了一个由机器人制造、系统集成、零部件生产、智能产业示范等生态链组成的产业集群。目前，温州瓯江口机器人产业园已投产41家企业，另有33家正在装修、准备入驻。' },
                ],
                summarize: '机器人产业将为温州转型升级和智能制造的发展提供有力支撑。过去两年，瓯江口机器人产业园联合达明机器人和温州技师学院，共建工业机器人产业学院，打造了“校、园、企”三位一体的职业教育联合体，为温州机器人应用产业培养高素质技能人才赋能助力。'
            }
        },
        {
            addr: '/news/one',
            date: '2023.12.23',
            title: '富轹科技冬季团建 学习 ·沟通 ·聚力',
            img: '',
            content: {
                subheading: `2023年12月23日，浙江富轹科技集团在温州九珑湖举办了年度末第二次团队建设活动。`,
                data: [
                    { img: require('../../assets/images/news2402291.png'), text: '本次团建活动继续围绕“全员营销”既定战略的课题，强化对企业文化的深刻理解。为了激发员工对公司战略的深刻认识和热情，邀请了各业务板块专家授课，通过对公司各个业务板块的针对性学习和全面了解，旨在提升员工的专业技能和市场洞察力。' },
                    { img: require('../../assets/images/news2402292.jpg'), text: '电梯事业部陈飞总  电梯业务知识培训' },
                    { img: require('../../assets/images/news2402293.jpg'), text: '飞鹿云张峰总  介绍飞鹿云各业务模块' },
                    { img: require('../../assets/images/news2402294.jpg'), text: '祖青总 企业文化团队素质培训' },
                    { img: require('../../assets/images/news2402295.jpg'), text: '汪总进行企业战略宣讲' },
                    { img: require('../../assets/images/news2402296.jpg'), text: '颁发“积极参与奖”' },
                    { img: require('../../assets/images/news2402297.jpg'), text: '在培训学习过程中，包括了丰富的互动环节，员工们积极参与和讨论，促进了跨部门之间的沟通和理解。活动在颁发“积极参与奖”的热烈气氛中落下帷幕，这次团建活动不仅成功地加强了员工对“全员营销”战略的理解，也有效提升了团队的士气和凝聚力。' },
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2023.12.05',
            title: '祝贺富轹科技集团成功竞得霞浦经济技术开发区优质地块',
            img: '',
            content: {
                subheading: '12月5日，浙江富轹科技集团旗下关联公司成功竞得福建省霞浦县松港街道小沙村优质地块，成交价格：140610000（壹亿肆仟零陆拾壹万元）。',
                data: [
                    { img: require('../../assets/images/news231505.jpg'), text: '' },
                    { img: require('../../assets/images/items_xiapu01.jpg'), text: '浙江富轹科技集团将与霞浦地方政府联合打造集智能制造、冷链储存、海产品展示、电子商务为一体的高端海洋科技城。' },
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2023.11.11',
            title: '温州团队开展“六顶思维帽”团建培训活动',
            img: '',
            content: {
                subheading: `11月11日，富轹科技集团组织温州常驻员工进行了一场以“6顶思维帽”游戏为形式，以“集团公司全员营销”为课题的团建培训活动。
                这次活动的目的在于“团队建立富有成效的企业文化和合作机制；个人培养多维、包容、高效的思维方式，并通过反复训练以巩固之。`,
                data: [
                    {
                        img: require('../../assets/images/news23111400.jpg'), text: `这种充分调动、寓教于乐，轻松而有效的团建方式是一次积极的尝试。后续我们将总结经验，结合工作实际，在集团内不断优化和推广。为提升员工综合素质、增强团队凝聚力，组织更多丰富而有效的团建活动，推进企业文化建设。
                    ` },
                    {
                        img: require('../../assets/images/news23111401.jpg'), text: `关于“六顶思维帽”:六顶思维帽是“创新思维之父”英国学者爱德华·德·波诺(Edward de Bono)博士开发的一种思维训练模式，是一个全面思考问题的模型。又称平行思考法，是一种同一时间只做一件事情的思考方法。
白色帽代表客观，红色帽代表情绪，黑色帽代表谨慎，黄色帽代表乐观，绿色帽代表创造，蓝色帽代表控制。` },
                    {
                        img: require('../../assets/images/news23111402.jpg'), text: `一个典型的六顶思维帽的应用步骤如下：
                    
1、陈述问题事实（白帽）
2、提出如何解决问题的建议（绿帽）
3、评估建议的优缺点：列举优点（黄帽）；列举缺点（黑帽）
4、对各项选择方案进行直觉判断（红帽）
5、归纳总结陈述，得出方案（蓝帽）` },
                    {
                        img: '', text: `为什么是帽子?

●不同颜色的帽子代表不同的思考规则。
●容易转换思考方式。
●帽子为组织思维提供了框架，使思维变得更加集中，更加有组织性，更有创造性。`
                    },
                    {
                        img: '', text: `6顶思维帽的价值

6顶思维帽提供了一种对问题和机会进行创造性思考或变通性思考的方法，使我们从更广的角度看问题，甚至从相反的角度来分析问题。它对人们思考以及讨论问题所起到的帮助在于:
1.角色扮演——思维的最大限制就是“自我防卫”，这些帽子使我们敢说，而不用担心伤害自我及他人。
2.引导注意力——6顶思维帽可以将我们的注意力引导到事情的6个层面。
3.方便——象征性的6顶思维帽提供了一种非常方便的方法，戴帽、摘帽、换帽，让你可以要求某人(包括你自己)变换思考的状态。
4.建立了游戏规则——6顶思维帽等于为思维游戏制定了一些规则，让人们在谈论和思维时有了共同的标准。
“思想的帽子”是一个很好的比喻，根据每顶帽子的喻义，我们可以辨析自己的态度和立场。开始时，这种方法好像很“做作"，但它提供了具有建设性和纲要性的思维框架，有助于整理问题，挖掘内在原因，换个角度看问题，能够将问分析得更透彻，更重要的是，能制定更好的决策与计划。`
                    },
                    {
                        img: '', text: `如何使用6顶思维帽

在大型或小型的会议讨论过程中，会议的组织和参与者可在会议进行的不同阶段，根据议题展开的情况，对6顶思维帽进行以下的些应用:
戴帽：
思维帽可以在思维的任何时候单一地使用，也可以将几顶帽子以一定的排列顺序合并起来使用，或者在思考前，按6顶思维帽的完整使用顺序建立一个思维的框架。
如果要对某事件或某问题进行充分讨论，那么，讨论小组中就要包括所有6种不同思维方式的人员。如果讨论小组的人员都是戴黑色帽子的，他们就不会支持革新或采用新的方法。
我们可以请同事或思考中的小组成员戴上特定颜色的帽子，或者我们请一个小组在几分钟之内使用某顶思维帽。例如:“我们停滞不前了。让我们戴上绿色的帽子，想想关于这个问题的新观点吧!"
值得一提的是，在整个思维过程中，蓝帽发挥着与众不同的作用。不管什么时候，不论我们建议下一步要用哪顶帽子时，我们实际上都是在使用蓝帽思维。
“请用蓝帽来决定我们想思考什么，我们要用哪顶思维帽。”
“我认为目前的讨论已偏离了我们的目标，我要戴上蓝帽，再陈述一下目标。”
“我想戴上我的蓝帽，问问我们能得出什么结论。”
蓝帽的使用不受其他帽子的限制，任何思维步骤都可以由它来提出。
摘帽：
我们可以请一个人或整个小组来摘掉某种特定颜色的帽子。我们推断正在进行的思维是某一类型，让人们从这种思维中脱离出来。例如:“好，这是很好的黑帽思维，让我们现在把黑帽收起来。”
换帽：
我们可以通过建议一位小组成员摘掉一个帽子，戴上另一个来完成思维的瞬间转换，同时我们也不会冒犯这个人，因为这不是攻击正在进行的思维而是要求改变。例如:“这是个不错的想法，现在请我们摘掉黄帽，戴上白帽，我们需要列出事实。”
传统性思维模式是把问题、事件、知识、研究所涉及的因素考虑得越复杂越是感觉万无一失。“6顶思维帽”突破了传统逻辑思维的单一模式，使我们将思考的不同方面分开进行，取代了一次解决所有问题的做法。集中分析信息(白帽)、利益(黄帽)、直觉(红帽)以及风险(黑帽)等，使人们可以依次对问题的不同侧面给予足够的重视和充分的考虑。它帮助人们做事更有效率，更专注，更加运用智慧的力量。`
                    },
                ],
                summarize: ''
            }
        },



        {
            addr: '/news/one',
            date: '2023.07.26',
            title: '富轹科技集团领导赴邯郸冀南新区考察',
            img: '',
            content: {
                subheading: '7月26日，浙江富轹科技集团有限公司副总裁汪振勇、麦弘毅、侯纪周一行到邯郸冀南新区考察，双方在管委会七楼东会议室召开座谈会议，对接交流相关事宜。邯郸冀南新区管委会主任杨万春，管委会副主任魏忠彦参加活动。',
                data: [
                    { img: require('../../assets/images/news072601.jpg'), text: '7月26日，浙江富轹科技集团有限公司副总裁汪振勇、麦弘毅、侯纪周一行到邯郸冀南新区考察，双方在管委会七楼东会议室召开座谈会议，对接交流相关事宜。邯郸冀南新区管委会主任杨万春，管委会副主任魏忠彦参加活动。' },
                    {
                        img: require('../../assets/images/news072602.jpg'), text: `杨万春说：
欢迎各位企业家，邯郸是一座等了你三千年的城。冀南新区是河北省设立的第三个战略发展新区，京津冀协同发展和中原经济区两大战略在这里交汇，区位优势明显、资源禀赋丰厚，是一块投资兴业的沃土。当前，新区正在实施创建国家高新技术产业开发区和建设滏阳新城两大主体战略，高新区创建与新城建设各项工作稳步推进，职业教育在这里蓬勃发展，产城教融合高质量发展势头强劲。近年来，新区立足区域产业定位，不断优化营商环境，创新开展“产业链+产业园”招商模式，持续招引高新企业、专精特新企业落户到新区，形成高端装备制造等产业聚集的良好局面。浙江富轹科技集团有限公司是一家从事技术服务、技术开发、技术咨询等业务的公司，在集成电路、自动化数字化、智能制造、产业园开发等领域基础雄厚、实践经验丰富。希望双方进一步加强对接沟通，寻找到契合点位，早日达成实质性合作，共同实现双赢目标。` },
                    {
                        img: require('../../assets/images/news072603.jpg'), text: `汪振勇说：
江富轹科技集团有限公司总部设于浙江省杭州市，是以服务国家战略性新兴产业的培育和发展为宗旨，依托创新的产业运营先进理念和商业模式，将政府、投资机构、优质的产业资源进行有效整合；专注于全国各类区域性产业园区项目规划及咨询服务，致力成为具有卓越实力及影响力的产业导入专家，构建以园区开发、产业投资、科技孵化为核心的产业资源聚合平台。邯郸冀南新区在特色产业集聚、生态治理、职业教育、城市建设等方面走在前列，独特的区位优势、深厚的资源禀赋和良好的营商环境成为投资兴业的理想之地。希望通过双方深入对接交流，尽快寻找到合作契合点，达成实质性合作。同时，我们将发挥集团优势，积极参与到新区建设中来，为新区发展贡献一份力量。` },
                    { img: require('../../assets/images/news072604.jpg'), text: '邯郸冀南新区管委会副主任魏忠彦主持座谈会，并介绍新区相关情况。' },
                    { img: require('../../assets/images/news072605.jpg'), text: '会后，考察团一行还到河北新富集团、河北运达风电设备有限公司、瑞宏新金属结构制造有限公司、中电光谷邯郸智造中心项目、邯郸·中关村信息谷创新中心、邯郸职教城、科创城、滏阳河生态修复工程（新区段）等地考察，实地了解产业生产、职业教育、城市建设、河流生态修复、项目建设等情况，并就相关问题进行深入交流。新区相关部门负责人参加活动。' },
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2023.06.13',
            title: '机器人产业园企业参加温州技师学院校园招聘',
            img: '',
            content: {
                subheading: '6月13日，一场主题为“技能造富 职等你来”技能人才岗位进校园招聘会在温州技师学院如火如荼地展开。新沃电气、中环机械、斯普威尔电气、贝立电力、朗森等多家瓯江口机器人产业园企业参加了本次招聘会。',
                data: [
                    { img: require('../../assets/images/recruit01.jpg'), text: '招聘会上，园区企业共提供了数十个招聘岗位，包括钣金、焊接、机电、激光操作等多种技术岗位。相关招聘受到了学生的极大关注，现场气氛热烈。' },
                    { img: require('../../assets/images/recruit02.jpg'), text: '在招聘会现场，温州技师学院共700多名今年预就业学生分时段、分批次参加了本次招聘会，各家企业展示了公司的产品和服务，向学生介绍了公司的发展历程和未来规划。同时，各家企业还安排了专业的人力资源招聘团队，为应聘者提供详细的职位介绍和面试指导，并耐心解答了应聘者的各种问题。' },
                ],
                summarize: '参会企业表示，此次校园招聘会办得非常成功，不仅为公司引进了优秀的人才，也让更多的学生了解了企业的发展方向和未来愿景。此次校园招聘会的成功举办，标志着机器人产业园在校企合作方面又迈出了坚实的一步，今后机器人产业园将继续为园区企业提供优质的招聘、技改、咨询等平台服务，共同推动园区的发展进程。'
            }
        },
        {
            addr: '/news/one',
            date: '2023.05.25',
            img: '',
            title: '海经区管委会调研瓯江口机器人实训中心',
            content: {
                subheading: '5月25日，温州海经区管委会组宣部董建泽部长一行来校调研瓯江口机器人实训中心，副校长叶文、瓯江口机器人产业园负责人，组织宣传统战部、人力资源部、产教合作部、继续教育学院、智能控制学院相关人员陪同。',
                data: [
                    { img: require('../../assets/images/center01.jpg'), text: '董建泽部长一行对现场学生演示的机器人手动示教颇感兴趣。瓯江口机器人产业园负责人介绍，瓯江口机器人实训中心承办了2023CIMC（“西门子杯”中国智能制造挑战赛）“智能产线与协作机器人赛项”初赛培训，这也是“西门子杯”首次进入温州。调研当天，来自泉州信息工程学院的师生正在现场进行培训。“西门子杯”中国智能制造挑战赛是由教育部高等学校自动化类专业教学指导委员会、西门子（中国）有限公司和中国仿真学会联合主办的国家级A类赛事。自2006年发展至今，已经成功举办16届，为目前中国智能制造领域规模最大、规格最高的学生类竞赛。' },
                    { img: require('../../assets/images/center02.jpg'), text: '' },
                ],
                summarize: '培训围绕智能型协作机器人核心技术开展，为师生在智能制造的理论知识和操作能力方面奠定了良好的基础。学校厚植培育技能人才土壤、创新技能人才培养方式，持续推进技能人才精准培养输送，助力区域经济社会高质量发展。'
            }
        },
        {
            addr: '/news/one',
            date: '2023.05.16',
            img: '',
            title: '瓯江口机器人实训中心成功举办“西门子杯”中国智能制造挑战赛初赛培训',
            content: {
                subheading: '近日，由瓯江口机器人产业园、台湾达明机器人公司与温州技师学院三方，合作建立的瓯江口机器人实训中心承接举办的2023CIMC（“西门子杯”中国智能制造挑战赛）“智能产线与协作机器人赛项”初赛培训圆满完成。这也是“西门子杯”中国智能制造挑战赛首次进入温州。',
                data: [
                    { img: require('../../assets/images/train01.jpg'), text: '“西门子杯”中国智能制造挑战赛由教育部高等学校自动化类专业教学指导委员会、西门子（中国）有限公司和中国仿真学会联合主办的国家级A类赛事。自2006年发展至今，已经成功举办16届，为目前中国智能制造领域规模最大、规格最高的学生类竞赛。' },
                    { img: require('../../assets/images/train02.jpg'), text: '此次大赛赛程跨度达五个月，参赛选手需参加线下培训，线上考试，校内选拔，全国初赛直至八月份的全国总决赛。大赛主要面向全国控制科学与工程、电气工程、机械工程、仪表科学与工程、信息与通讯工程、计算机科技与技术等相关学科的研究生、本科生，和全国自动化类、机电设备类、机械设计制造类、电子信息类、计算机类及通信类等相关专业的高校学生，以企业真实的工程项目和科研项目作为竞赛赛题，以真实的工业设备和工业环境作为赛场，以工业企业的工程标准作为考核评分指标，全面锻炼学生解决复杂工程问题的综合能力、系统思维，开赛以来获得了参赛院校和师生的积极反响和称赞。' },
                ],
                summarize: ''
            }
        },
        {
            addr: '/news/one',
            date: '2023.05.09',
            img: '',
            title: '瓯江口机器人实训基地揭牌',
            content: {
                subheading: '5月25日，温州海经区管委会组宣部董建泽部长一行来校调研瓯江口机器人实训中心，副校长叶文、瓯江口机器人产业园负责人，组织宣传统战部、人力资源部、产教合作部、继续教育学院、智能控制学院相关人员陪同。',
                data: [
                    { img: require('../../assets/images/opening01.jpg'), text: '温州市人民政府副市长章月影，温州海洋经济发展示范区党工委书记、管委会主任黄阳栩，市经济与信息化局党委委员、副局长黄寿君，市人力资源和社会保障局党组成员、副局长庄加灵，中共温州市委社会建设委员会专职副主任许绍策，及温州技师学院相关领导参加了仪式。' },
                    { img: require('../../assets/images/opening02.jpg'), text: '海经区管委会主任黄阳栩，温州技师学院校长刘杰，瓯江口机器人产业园及台湾达明机器人公司的代表，共同为实训基地揭牌' },
                    { img: require('../../assets/images/opening03.jpg'), text: '瓯江口机器人实训基地位于温州技师学院内，面积约600平米，是目前温州规模最大的一个功能齐全、设备先进的现代化机器人实训及研发基地。实训基地内配置了最新型的视觉融合协作机器人、机器人仿真软件、机器人编程软件、机器人自动化生产线等各种机器人研发和制造所需的设备和工具，并配备了专业的培训教师及技术人员，可以为学生和企业提供全方位的机器人及自动化实践培训服务，并为企业提供各类机器人与自动化的定制研发服务。' },
                    { img: require('../../assets/images/opening04.jpg'), text: '实训基地的建成，将吸引更多的优秀人才加入机器人产业，培养更多的机器人专业人才。同时，实训基地也可以为学生提供实践机会，让他们更好地了解和掌握机器人研发和制造的技术，提高他们的就业竞争力，有力促进温州机器人与自动化技术的不断进步和创新，为产业升级做出更大的贡献。' },
                ],
                summarize: ''
            }
        }
    ],
    items_datas: [
        {
            addr: '/multiple/one',
            date: '',
            title_cn: '大信智谷-瓯江口机器人产业园',
            img: require('../../assets/images/items_ojk01.jpg'),
            title_en: 'Daxin i valley- Oujiangkou Robot Industrial Park',
            content: {
                subheading: '瓯江口机器人产业园是由富轹科技导入中信华晟基金与阿里云在温州瓯江口共同打造的高端工业园区，于 2019 年 10 月 21 日在互联网大会签约，2020 年 3 月初正式开工建设，为浙江省重点项目，“152”工程。',
                subheading_en: 'Oujiangkou Robot Industrial Park is a high-end industrial park jointly built by Citic Huasheng Fund and Alibaba Cloud in Oujiangkou, Wenzhou, introduced by Fuke Technology. It was signed at the Internet Conference on October 21, 2019, and officially started construction in early March 2020. It is a key project in Zhejiang Province, the “152” project.',
                data: [
                    { img: require('../../assets/images/items_ojk01.jpg'), text: '园区总用地面积约355 亩， 总建筑面积约 60 万平方米， 总投资约 25亿元。聚集多家领先机器人制造商、智能科技企业。', en: 'The total land area of the park is approximately 355 acres, with a total construction area of approximately 600000 square meters and a total investment of approximately 2.5 billion yuan. Gathering multiple leading robot manufacturers and intelligent technology enterprises.' },
                    { img: require('../../assets/images/items_ojk02.jpg'), text: '园区重点建设机器人研发和生产基地、机器人应用示范区、机器人博物馆及配套工程。将打造一个以机器人制造、系统集成、零部件生产、智能产业示范等生态链组成的产业集群。力争成为浙江乃至全国的智能制造示范基地，并重塑城市工业新格局、点亮温州智造新未来。', en: 'The park focuses on building robot research and production bases, robot application demonstration areas, robot museums, and supporting projects. We will create an industrial cluster composed of ecological chains such as robot manufacturing, system integration, component production, and intelligent industry demonstration. Strive to become an intelligent manufacturing demonstration base in Zhejiang and even the whole country, and reshape the new pattern of urban industry, lighting up a new future of intelligent manufacturing in Wenzhou.' },
                ],
                summarize: ''
            }
        },
        {
            addr: '/multiple/one',
            date: '',
            title_cn: '大信智谷-霞浦海洋数字经济产业园',
            img: '',
            title_en: 'DAXIN iVALLEY · XIAPU Marine Digital Economy Industrial Park',
            content: {
                subheading: '霞浦海洋数字经济产业园是大信智谷依托国家、区域发展战略和政策环境优势，深入推进一二三产业融合发展，在福建霞浦打造的集“生产+加工+科技研发+品牌+电商”全产业链的现代海洋数字经济产业园。',
                subheading_en: 'Xiapu Marine Digital Economy Industrial Park is a modern marine digital economy industrial park built by DAXIN iVALLEY in Xiapu, Fujian Province, relying on national and regional development strategies and policy environment advantages to deeply promote the integration of primary, secondary, and tertiary industries. It integrates the entire industrial chain of “production+processing+technology research and development+brand+e-commerce”.',
                data: [
                    { img: require('../../assets/images/items_xiapu01.jpg'), text: '产业园由富轹科技集团联合知名电商平台阿里巴巴、搭建第三方平台子平台运作模式，助力“霞浦海洋经济商务产业集聚区”打造，带领园区品牌开拓国内外市场。项目建设内容包括：海产品加工智能车间、海产品精加工车间、海产品智慧冷链物流基地、产品展销中心、综合配套大楼（含直播电商基地、总部办公基地、水产育苗科研中心、智能化设备定制中心、员工配套服务）等。', en: 'The industrial park is jointly operated by Fully Technology Group and well-known e-commerce platform Alibaba to establish a third-party platform operation model, helping to build the “Xiapu Marine Economic and Commercial Industry Cluster Zone” and leading the park brand to explore domestic and foreign markets. The construction content of the project includes: intelligent workshop for seafood processing, precision processing workshop for seafood, intelligent cold chain logistics base for seafood, product exhibition and sales center, comprehensive supporting building (including live streaming e-commerce base, headquarters office base, aquatic breeding research center, intelligent equipment customization center, and employee supporting services), etc.' },
                    { img: require('../../assets/images/items_xiapu02.jpg'), text: '霞浦海洋数字经济产业园打造配套齐全、运营模式创新、多功能型产业园区“实体产业+线上产业”的示范基地；打造海产品智能化精加工车间，力争成为省级海洋产业数字化、自动化转型示范基地；打造海产品加工”智能工厂”的示范基地，致力于成为推动霞浦海洋经济转型更新的创新智能引擎。', en: 'The Xiapu Marine Digital Economy Industrial Park aims to create a demonstration base for the “physical industry+online industry” of a fully equipped, innovative operation model, and multifunctional industrial park; Build an intelligent precision processing workshop for seafood, striving to become a provincial-level demonstration base for digital and automated transformation of the marine industry; Building a demonstration base for “intelligent factories” in seafood processing, committed to becoming an innovative intelligent engine for promoting the transformation and updating of Xiapu’s marine economy.' },
                ],
                summarize: ''
            }
        },
        {
            addr: '/multiple/one',
            date: '',
            title_cn: '上海大信无人机通航港',
            img: '',
            title_en: 'SHANGHAI DAXIN UAV NAVIGATION PORT',
            content: {
                subheading: '项目由大信科融联合中信海直发展有限公司联合投资建设，项目占地200亩，总投资15亿元，汇聚了旋翼机制造企业、无人机整机制造企业，无人机配套设备制造企业 ，无人机配套软件开发企业，无人机驾驶员培训企业，并建立大信5G 泛低空无人机大数据中心、智能无人机华东制造中心基地。',
                subheading_en: 'The project is jointly invested and constructed by Daxin Kerong and CITIC Offshore Helicopter, the project covers an area of 200 mu, with a totalinvestment of 1.5 billion yuan. It brings together rotorplane manufacturer, drone complete machine manufacturing enterprises, drone corollary equipment manufacturers, drone bundled software developer, UAV drone operator training institutes, building Daxin 5G extensive low altitude drone big data center and East China drone Intelligent manufacturing base.',
                data: [
                    { img: require('../../assets/images/items_shw01.jpg'), text: '', en: '' },
                    { img: require('../../assets/images/items_shw02.jpg'), text: '', en: '' },
                ],
                summarize: ''
            }
        }
    ],
    about_datas: {
        title: '品牌简介',
        title_en: 'BRAND INTRODUCTION',
        img: require('../../assets/images/dxzg_about.jpg'),
        foot_cn: '大信智谷，智慧引领未来工业地产。',
        foot_en: 'DAXIN i VALLEY, wisdom leads the future of industrial real estate.',
        data: [
            {
                cn: '大信智谷是由富轹科技集团与大信科融、中信、中国电子及阿里云等大型集团的旗下机构联合打造，提供产业导入及投资、园区开发及运营等全链条服务的、具有优秀资源整合能力的工业地产综合平台。',
                en: 'DAXIN i VALLEY is a comprehensive industrial real estate platform with excellent resource integration capability, which is jointly built by Fully Technology Group, Daxin Kerong, CITIC, China Electronics, Alibaba Cloud and other large groups. It provides full chain services such as industrial introduction and investment, park development and operation.'
            },
            {
                cn: '秉承“实业与金融相互依存，传统与新兴彼此促进”的中信理念，大信智谷致力于持续推动中国传统工业地产向智慧地产升级，逐步形成和造就中国产业导入和园区规划的领导品牌。',
                en: 'Adhering to the CITIC philosophy of “interdependence between industry and finance, and mutual promotion between tradition and emerging”, DAXIN i VALLEY is committed to continuously promoting the upgrading of traditional industrial real estate in China to smart real estate, gradually forming and cultivating a leading brand for China’s industrial introduction and park planning.'
            },
            {
                cn: '大信智谷不仅为地方政府提供含高端制造园区开发、产业聚集、企业甄选等区域型经济发展能效升级的整体解决方案，同时也为企业提供产业用地适配、智能制造升级、知识产权、品牌策划、政策咨询等个性化解决方案。此外，大信智谷还为合作伙伴提供基于工业地产的资产优化配置、项目全生命周期管理、软资源要素的优化整合。无论是地方政府、企业还是合作伙伴，大信智谷都能够提供全方位、个性化的服务，为客户的发展提供有力支持。',
                en: 'DAXIN i VALLEY not only provides local governments with comprehensive solutions for regional economic development and energy efficiency upgrading, including high-end manufacturing park development, industrial clustering, and enterprise selection, but also personalized solutions for enterprises such as industrial land adaptation, intelligent manufacturing upgrading, intellectual property, brand planning, and policy consulting. In addition, DAXIN i VALLEY also provides partners with optimized asset allocation based on industrial real estate, project lifecycle management, and optimization and integration of soft resource elements. Whether it is local governments, enterprises, or partners, DAXIN i VALLEY can provide comprehensive and personalized services, providing strong support for the development of customers.'
            },
        ],
    },
    service_datas: [
        {
            addr: '/multiple/one',
            title: '科技孵化',
            title_cn: '作为大信智谷的控股母公司，富轹科技集团与中国电子、阿里巴巴、哈工大、熊猫电子等产业龙头深度合作，打造各高新技术领域产业运营和企业孵化的平台',
            img: require('../../assets/images/services01.png'),
            title_en: '',
            content: [
                { title: '◎ 机器人产业', discript: '富轹集团与中电熊猫、哈工大机器人集团、格润智控、台湾达明等国内外知名的工业机器人企业开展了深度合作，在电子、制鞋、汽摩配、装备制造等领域的自动化设备改造方面投入了具体的研发费用，并形成了多行业、自动化设备+数字化平台的整体解决方案。' },
                { title: '◎ IC集成电路', discript: '富轹科技集团与中国电子旗下的中电港合资成立了中电港科技，专注于集成电路应用的开发，与国内外多家IC原厂合作，形成从IC应用 、模块开发、IC贸易、金融服务为一体的集成电路应用服务。' },
                { title: '◎ 高新电子', discript: '富轹科技集团以控股的雷亚电子为基础，专注于电源、物联网设备领域的开发，形成了设备制造、物联网解决方案、国际贸易、电商服务为一体的产业平台。' },
            ]
        },
        {
            addr: '/multiple/one',
            title: '产业导入',
            title_cn: '富轹科技集团以“科技+投资”为核心模式，聚焦区域产业链，赋能产业升级，融合数字经济，助力地方政府高质量发展制造业的目标。富轹产业基金支持运作，致力于政府产业规划、企业发展需求、金融产业资本的对接、整合和转化。',
            img: require('../../assets/images/services02.jpg'),
            title_en: '通过强强联合，全面发展金融资本、互联网、智能制造等领域的战略合作。以中信旗下华晟基金为代表的金融战略合作伙伴，通过专业化投资运营和资源整合，提供全链条产业金融综合服务；以阿里云为代表的互联网战略合作伙伴，共同建设地方工业互联网中心；以哈工严格集团、中电熊猫装备、中信重工为代表的智能制造战略合作伙伴，共同推进传统企业智能化改造。',
            content: []
        },
        {
            addr: '/multiple/one',
            title: '园区开发',
            title_cn: '服务地方政府， 配合区域发展规划进行高端主题产业园的策划立项 、招商引资 、开发建设及运营管理。已成功立项并完成建设开发如：瓯江口机器人产业园、中信海直上海无人机通航港、中国电子温州信息港等一批优质的产业园项目。',
            img: require('../../assets/images/services03.jpg'),
            title_en: 'Provide partners with optimized asset allocation based on industrial real estate, project lifecycle management, and optimized integration of soft resource elements.',
            content: []
        },
        {
            addr: '/multiple/one',
            title: '数智运营',
            title_cn: '以可视化、物联网技术为基础，运用AI人工智能、大数据、云计算、智慧消防、机器人、融合通信等先进技术，实现车辆识别、人脸识别、火灾预警、智能运维、智能分析、消防数据上报、机器人巡检，保证了音视频、数据的高速传输，从而完成了数据大融合和海量数据云存储，实现整个园区的综合管控和调度指挥，且大屏大数据魔墙可使生产数据、业务数据图表化实时上墙，为安全生产、安全监管提供有力保障。',
            img: require('../../assets/images/services02.png'),
            title_en: 'Provide partners with optimized asset allocation based on industrial real estate, project lifecycle management, and optimized integration of soft resource elements.',
            content: []
        }
    ],
    business_datas: [
        {
            addr: '',
            title: '',
            title_cn: '大信智谷不仅为地方政府提供含高端制造园区开发、产业聚集、企业甄选等区域型经济发展能效升级的整体解决方案；同时也为企业提供产业用地适配、智能制造升级、知识产权、品牌策划、政策咨询等个性化解决方案。此外，大信智谷还为合作伙伴提供基于工业地产的资产优化配置、项目全生命周期管理、软资源要素的优化整合。无论是地方政府、企业还是合作伙伴，大信智谷都能够提供全方位、个性化的服务，为客户的发展提供有力支持。',
            img: require('../../assets/images/business01.png'),
            title_en: '',
            content: [
                { title: '◎ 孵化导入', discript: '发挥平台优势，对接智能制造、互联网技术的领军品牌，聚焦区域产业链，赋能产业升级，融合数字经济，服务地方工业高质量发展。' },
                { title: '◎ 园区开发', discript: '服务地方政府，配合区域发展规划进行高端主题产业园区的策划立项、招商引资、开发建设及运营管理。' },
                { title: '◎ 产业投资', discript: '高效整合金融资源，依托品牌基金，以产业投资为核心，服务国家战略，支持项目建设。' },
            ]
        }
    ],
    other_datas: {
        title: '战略规划',
        title_en: 'STRATEGIC PLANNING',
        img: require('../../assets/images/dxzg_about.jpg'),
        foot_cn: '大信理念',
        foot_en: 'DAXIN i VALLEY, wisdom leads the future of industrial real estate.',
        data: [
            {
                cn: '未来1~3年：深入部署品牌战略；持续推进优质产业项目，建设运营8-10个大信智谷高端园区，运营面积力争达到200万平方米。',
            },
            {
                cn: '未来3~5年：提升公司品牌知名度、广泛度、美誉度，导入建设5个大型单体项目，建设运营20个大信智谷园区，运营面积力争达到500万平方米。',
            },
            {
                cn: '未来5~10年：深耕长三角及珠三角，开并拓二三线城市及城镇化新兴产业市场，实现工业地产智慧化运营的战略构想，力争运营面积达到1500万平方米。',
            },
        ],
        right: {
            title: '大信理念',
            title_en: 'PHILOSOPHY',
            img: '',
            content: ['—— 实业与金融相互依存，传统与新兴彼此促进。', '—— 秉持共赢发展，聚合优质资源，服务铸就品牌。', '—— 打造最具影响力的全链条产业服务平台。']
        },
        bottom: {
            title: '诚邀合作',
            title_en: 'SINCERELY INVITE CONPERATION',
            img: '',
            content: ['大信智谷立足于雄厚的产业基础和实践经验，以产业园咨询为起点，在科技赋能、企业孵化、资本导入、产业投资、园区开发、数智运营等领域，与众多央企国企、各领域领先品牌、以及地方政府形成了长期战略合作。我们面向各级地方政府，各类企业及项目，提供全链条的、专业的智能化、数字化产业投资运营咨询服务。大信智谷产业智库，热忱欢迎您的垂询与合作！']
        }
    },
    info_datas: [
        {
            addr: '',
            data: '国家高新技术产业开发区可享受国家哪些优惠政策？',
            title: '高新技术企业按15%的税率征收所得税，其中出口产品产值达到当年总产值70%以上的，按10%税率征收所得税',
            img: require('../../assets/images/information01.jpg'),
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '新办的高新技术企业，从投产年度起，两年内免征所得税，新办的中外合资经营的高新技术企业，合营期在十年以上的，可从获利年度起，头两年免征所得税',
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '内资办的高新技术企业新建技术开发和生产经营用房，免征建设税（或投资方向调节税）',
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '高新技术企业用于高新技术开发和高新技术产品生产的仪器、设备，可实行快速折旧',
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '经海关批准，高新技术企业可在高新区内设保税仓库、保税工厂',
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '高新技术企业生产的出口产品，除国家限制出口或者有规定的产品以外，免征出口关税',
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '高新技术产业开发区内的基础设施建设和生产、经营性基本建设项目，国家每年安排一定数额的基本建设贷款和投资规模，并可发行一定额度的长期债券，向社会筹集资金',
            content: {}
        },
        {
            addr: '',
            data: '',
            img: '',
            title: '国家规定的其他优惠政策',
            content: {}
        }
    ],

};

export default datas;